import { ce as Ze } from "./OBTResizeContainer-CIXocf0-.js";
import { A as jl, a as Ll, b as Dl, c as Ml, d as Tl, e as Rl, f as Pl, C as Ol, g as ql, h as Gl, i as Wl, j as zl, k as Kl, l as Hl, m as Vl, n as Ul, o as Ql, p as Yl, q as Jl, r as Zl, s as ei, t as ti, u as ai, v as ni, w as oi, x as si, y as ri, z as ci, B as li, D as ii, E as di, F as _i, G as mi, H as ui, I as pi, J as Ei, K as fi, L as bi, M as yi, N as gi, O as hi, P as vi, Q as ki, R as Ni, S as Ai, T as wi, U as $i, V as xi, W as Xi, X as Ci, Y as Si, Z as Bi, _ as Fi, $ as Ii, a0 as ji, a1 as Li, a2 as Di, a3 as Mi, a4 as Ti, a5 as Ri, a6 as Pi, a7 as Oi, a8 as qi, a9 as Gi, aa as Wi, ab as zi, ac as Ki, ad as Hi, ae as Vi, af as Ui, ag as Qi, ah as Yi, ai as Ji, aj as Zi, ak as ed, al as td, am as ad, an as nd, ao as od, ap as sd, aq as rd, ar as cd, as as ld, at as id, au as dd, av as _d, aw as md, ax as ud, ay as pd, az as Ed, aA as fd, aB as bd, aC as yd, aD as gd, aE as hd, aF as vd, aG as kd, aH as Nd, aI as Ad, aJ as wd, aK as $d, aL as xd, aM as Xd, aN as Cd, aO as Sd, aP as Bd, aQ as Fd, aR as Id, cf as jd, aS as Ld, aT as Dd, aU as Md, aV as Td, aW as Rd, aX as Pd, aY as Od, aZ as qd, a_ as Gd, a$ as Wd, b0 as zd, b1 as Kd, b2 as Hd, b3 as Vd, b4 as Ud, b5 as Qd, b6 as Yd, b7 as Jd, b8 as Zd, b9 as e_, ba as t_, bb as a_, bc as n_, bd as o_, be as s_, bf as r_, bg as c_, bh as l_, bi as i_, bj as d_, bk as __, bl as m_, bm as u_, bn as p_, bo as E_, bp as f_, bq as b_, br as y_, bs as g_, bt as h_, bu as v_, bv as k_, bw as N_, bx as A_, by as w_, bz as $_, bA as x_, bB as X_, bC as C_, bD as S_, bE as B_, bF as F_, bG as I_, bH as j_, bI as L_, bJ as D_, bK as M_, bL as T_, bM as R_, bN as P_, bO as O_, bP as q_, bQ as G_, bR as W_, bS as z_, bT as K_, cg as H_, bU as V_, bV as U_, bW as Q_, ch as Y_, bX as J_, bY as Z_, bZ as em, b_ as tm, b$ as am, c0 as nm, c1 as om, c2 as sm, c3 as rm, c4 as cm, c5 as lm, c6 as im, c7 as dm, c8 as _m, c9 as mm, ca as um, cb as pm, cc as Em, cd as fm } from "./OBTResizeContainer-CIXocf0-.js";
import * as e from "react";
import { useState as A, useEffect as Z, useRef as J, useCallback as me, Fragment as dt } from "react";
import { p as et, e as _t, o as mt, h as ut, d as pt } from "./format-CVedM0M8.js";
import { A as ym, a as gm, b as hm, c as vm, f as km, g as Nm, i as Am, j as wm, k as $m, l as xm, m as Xm, n as Cm, s as Sm, t as Bm } from "./format-CVedM0M8.js";
const Wc = {
  primary: "#1d4ed8",
  primaryBg: "#dbeafe",
  headerBg: "#1f2937",
  text: "#374151",
  textMuted: "#6b7280",
  border: "#e5e7eb",
  surface: "#f3f4f6"
}, Le = "poc_portal_token", ne = "poc_portal_refresh", Be = "auth:session-expired", De = window.location.hostname === "dev.gennolab.co.jp" ? "" : "https://dev.gennolab.co.jp";
let tt = De + "/chat-api/api/auth";
function zc(t) {
  t.authBase && (tt = t.authBase);
}
function Xe(t) {
  try {
    const a = t.split(".")[1].replace(/-/g, "+").replace(/_/g, "/");
    return JSON.parse(decodeURIComponent(escape(atob(a))));
  } catch {
    return {};
  }
}
function he(t, a = 30) {
  const n = Xe(t).exp;
  return !n || n * 1e3 < Date.now() + a * 1e3;
}
function at(t = 30) {
  const a = localStorage.getItem(ne);
  if (!a) return !0;
  const n = Xe(a).exp;
  return !!n && n * 1e3 < Date.now() + t * 1e3;
}
function ve() {
  return localStorage.getItem(Le);
}
function Et(t, a) {
  localStorage.setItem(Le, t), a && localStorage.setItem(ne, a);
}
function ft() {
  localStorage.removeItem(Le), localStorage.removeItem(ne), nt();
}
function ye(t) {
  if (t !== void 0) {
    const a = localStorage.getItem(ne);
    if (a && a !== t) return !1;
  }
  return ft(), window.dispatchEvent(new Event(Be)), !0;
}
function Kc(t) {
  return window.addEventListener(Be, t), () => window.removeEventListener(Be, t);
}
let ge = null;
const bt = 2147483647;
function yt() {
  if (nt(), at()) {
    ye();
    return;
  }
  const t = localStorage.getItem(ne), a = t ? Xe(t).exp : void 0;
  if (!a) return;
  const n = Math.min(Math.max(a * 1e3 - Date.now() - 30 * 1e3, 0), bt);
  ge = setTimeout(() => {
    ge = null, yt();
  }, n);
}
function nt() {
  ge !== null && (clearTimeout(ge), ge = null);
}
let $e = null;
const gt = "poc_portal_refresh_lock";
async function ht(t) {
  const a = typeof navigator != "undefined" ? navigator.locks : void 0;
  return a ? a.request(gt, t) : t();
}
function ot(t) {
  return $e || ($e = vt(t)), $e;
}
async function vt(t) {
  try {
    return await ht(async () => {
      const a = ve();
      return a && !he(a) && a !== t ? a : await st(!1);
    });
  } finally {
    $e = null;
  }
}
async function st(t) {
  const a = localStorage.getItem(ne);
  if (!a)
    return ye(), null;
  let n;
  try {
    n = await fetch(tt + "/refresh", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ refreshToken: a })
    });
  } catch {
    return null;
  }
  if (!n.ok) {
    if (n.status >= 500) return null;
    const r = localStorage.getItem(ne), s = ve();
    if (r && r !== a) {
      if (s && !he(s)) return s;
      if (!t) return st(!0);
    }
    return ye(a), null;
  }
  const o = await n.json().catch(() => ({}));
  return o.access_token ? (Et(o.access_token, o.refresh_token), o.access_token) : (ye(a), null);
}
async function kt() {
  if (at())
    return ye(), null;
  const t = ve();
  return t && !he(t) ? t : ot();
}
const xe = "poc_portal_active_aff:", Nt = "X-Active-Com", At = "X-Active-Dept";
function Me(t = ve()) {
  return t && Xe(t).preferred_username || null;
}
function Fe(t) {
  if (!t) return null;
  try {
    const a = JSON.parse(t);
    if (Number.isInteger(a == null ? void 0 : a.comSq) && typeof (a == null ? void 0 : a.deptCd) == "string" && a.deptCd)
      return { comSq: a.comSq, deptCd: a.deptCd };
  } catch {
  }
  return null;
}
function Te(t = Me()) {
  if (!t) return null;
  try {
    return Fe(localStorage.getItem(xe + t));
  } catch {
    return null;
  }
}
function Hc(t, a) {
  if (t)
    try {
      a ? localStorage.setItem(xe + t, JSON.stringify(a)) : localStorage.removeItem(xe + t);
    } catch {
    }
}
function Vc(t) {
  const a = (n) => {
    const o = Me();
    if (!o || n.key !== xe + o) return;
    const r = Fe(n.oldValue), s = Fe(n.newValue);
    (r == null ? void 0 : r.comSq) === (s == null ? void 0 : s.comSq) && (r == null ? void 0 : r.deptCd) === (s == null ? void 0 : s.deptCd) || t(s, r);
  };
  return window.addEventListener("storage", a), () => window.removeEventListener("storage", a);
}
function wt(t) {
  const a = Te(Me(t));
  return a ? { [Nt]: String(a.comSq), [At]: a.deptCd } : {};
}
async function ie(t, a = {}) {
  const n = (s) => {
    var m;
    const l = (m = a.headers) != null ? m : {}, d = Object.keys(l).map((_) => _.toLowerCase()), c = wt(s), i = {};
    return Object.keys(c).forEach((_) => {
      d.indexOf(_.toLowerCase()) < 0 && (i[_] = c[_]);
    }), {
      ...a,
      headers: { ...l, ...s ? { Authorization: "Bearer " + s } : {}, ...i }
    };
  }, o = await kt();
  let r = await fetch(t, n(o));
  if (r.status === 401 && o) {
    const s = await xt(o);
    s && (r = await fetch(t, n(s)));
  }
  return r;
}
const $t = 3e4;
let Re = 0;
async function xt(t) {
  const a = ve();
  if (a && a !== t && !he(a)) return a;
  if (!he(t)) {
    const n = Date.now();
    if (n - Re < $t) return null;
    Re = n;
  }
  return ot(t);
}
const Pe = "JPY";
let Ne = null;
function rt() {
  return Ne || (Ne = ie(`${De}/chat-api/api/basicinfo/common/companies`).then((t) => t.ok ? t.json() : []).catch(() => []).then((t) => (t.length || (Ne = null), t))), Ne;
}
function Xt(t, a) {
  var o, r, s;
  const n = (o = t.find((l) => l.comSq === a)) != null ? o : t[0];
  return n && (s = (r = n.dispCurCd) != null ? r : n.baseCurCd) != null ? s : null;
}
function Uc() {
  return rt().then((t) => {
    var n;
    const a = ct(t, (n = Te()) == null ? void 0 : n.comSq);
    a && et(a);
  }, () => {
  });
}
function ct(t, a) {
  var o, r;
  const n = (o = t.find((s) => s.comSq === a)) != null ? o : t[0];
  return (r = n == null ? void 0 : n.baseCurCd) != null ? r : null;
}
function Ct(t, a) {
  return { code: t, digits: pt(t), fmt: (n) => ut(n, t), unit: mt(t, a), text: _t(t, a) };
}
function St(t) {
  const [a, n] = A(Pe), [o, r] = A(Pe);
  return Z(() => {
    let s = !0;
    return rt().then((l) => {
      var m;
      const d = (m = Te()) == null ? void 0 : m.comSq, c = Xt(l, d), i = ct(l, d);
      s && (c && n(c), i && (r(i), et(i)));
    }), () => {
      s = !1;
    };
  }, []), Ct(a, { base: o, ...t });
}
function Qc({ className: t, hideBaseUnit: a = !0 }) {
  const { unit: n } = St({ hideBaseUnit: a });
  return n ? /* @__PURE__ */ e.createElement("span", { className: t, "data-currency-unit": !0 }, n) : null;
}
let de = De + "/chat-api/api/comments";
function Yc(t) {
  t.base && (de = t.base);
}
function Bt(t) {
  return t.parentId !== void 0 && t.parentId !== null;
}
async function ke(t) {
  const a = await t.json().catch(() => ({}));
  if (!t.ok) throw new Error("요청을 처리하지 못했습니다. 잠시 후 다시 시도하세요.");
  return a;
}
async function Oe(t, a, n, o, r) {
  const s = new URLSearchParams({ targetType: t, targetId: a, page: String(n), size: String(o) }), l = await ie(`${de}?${s}`, { cache: "no-store", signal: r });
  return ke(l);
}
async function Ft(t, a, n, o) {
  const r = await ie(de, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ targetType: t, targetId: a, content: n, parentId: o })
  });
  return ke(r);
}
async function It(t, a) {
  const n = await ie(`${de}/${t}`, {
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ content: a })
  });
  return ke(n);
}
async function jt(t) {
  const a = await ie(`${de}/${t}`, { method: "DELETE" });
  return (await ke(a)).status;
}
async function Lt(t, a, n) {
  if (a.length === 0) return {};
  const o = new URLSearchParams({ targetType: t, targetIds: a.join(",") }), r = await ie(`${de}/counts?${o}`, { cache: "no-store", signal: n });
  return (await ke(r)).counts;
}
const qe = 50;
function Ie(t) {
  return t.parentId === void 0 || t.parentId === null;
}
function Dt(t, a) {
  if (Ie(a)) return [...t, a];
  const n = a.parentId;
  let o = -1;
  for (let r = 0; r < t.length; r += 1)
    (t[r].id === n || t[r].parentId === n) && (o = r);
  return o < 0 ? [...t, a] : [...t.slice(0, o + 1), a, ...t.slice(o + 1)];
}
function ue(t, a) {
  return a;
}
function Mt(t, a) {
  const [n, o] = A([]), [r, s] = A(!0), [l, d] = A(!0), [c, i] = A(null), [m, _] = A(0), [u, f] = A(0), y = t + " " + a, E = J(y);
  E.current = y;
  const [h, w] = A(0), X = me(() => w((b) => b + 1), []);
  Z(() => {
    const b = new AbortController(), v = y;
    return o([]), f(0), _(0), i(null), s(!0), d(!0), Oe(t, a, 0, qe, b.signal).then((g) => {
      E.current === v && (o(g.items), _(g.total));
    }).catch((g) => {
      b.signal.aborted || E.current !== v || i(ue(g, "댓글을 불러오지 못했습니다."));
    }).finally(() => {
      E.current === v && (s(!1), d(!1));
    }), () => b.abort();
  }, [t, a, y, h]);
  const O = n.filter(Ie).length < m, q = me(() => {
    if (r || !O) return;
    const b = u + 1, v = E.current;
    s(!0), Oe(t, a, b, qe).then((g) => {
      E.current === v && (o((S) => [...S, ...g.items]), _(g.total), f(b));
    }).catch((g) => {
      E.current === v && i(ue(g, "댓글을 더 불러오지 못했습니다."));
    }).finally(() => {
      E.current === v && s(!1);
    });
  }, [r, O, u, t, a]), V = me(async (b, v) => {
    const g = b.trim();
    if (!g) return !1;
    const S = -Date.now(), B = {
      id: S,
      targetType: t,
      targetId: a,
      parentId: v != null ? v : null,
      authorName: "나",
      content: g,
      createdAt: (/* @__PURE__ */ new Date()).toISOString(),
      deleted: !1,
      mine: !0,
      pending: !0
    }, D = E.current;
    o((j) => Dt(j, B)), i(null);
    try {
      const j = await Ft(t, a, g, v);
      return E.current !== D || (o((U) => U.map((k) => k.id === S ? j : k)), v === void 0 && _((U) => U + 1)), !0;
    } catch (j) {
      return E.current !== D || (o((U) => U.filter((k) => k.id !== S)), i(ue(j, "댓글을 등록하지 못했습니다."))), !1;
    }
  }, [t, a]), C = me(async (b, v) => {
    const g = v.trim();
    if (!g) return !1;
    const S = E.current;
    try {
      const B = await It(b, g);
      return E.current !== S || o((D) => D.map((j) => j.id === b ? B : j)), !0;
    } catch (B) {
      return E.current === S && i(ue(B, "댓글을 수정하지 못했습니다.")), !1;
    }
  }, []), _e = me(async (b) => {
    const v = E.current;
    try {
      const g = await jt(b);
      return E.current !== v ? !0 : g === "soft-deleted" ? (o((S) => S.map((B) => B.id === b ? { ...B, deleted: !0, mine: !1, content: void 0, authorName: void 0 } : B)), !0) : (o((S) => {
        const B = S.find((k) => k.id === b), D = S.filter((k) => k.id !== b);
        if (!B) return D;
        if (Ie(B))
          return _((k) => Math.max(0, k - 1)), D;
        const j = B.parentId, U = D.find((k) => k.id === j);
        return U && U.deleted && !D.some((k) => k.parentId === j) ? (_((k) => Math.max(0, k - 1)), D.filter((k) => k.id !== j)) : D;
      }), !0);
    } catch (g) {
      return E.current === v && i(ue(g, "댓글을 삭제하지 못했습니다.")), !1;
    }
  }, []);
  return {
    items: n,
    loading: r,
    initialLoading: l,
    error: c,
    count: n.filter((b) => !b.deleted).length,
    hasMore: O,
    loadMore: q,
    reload: X,
    add: V,
    edit: C,
    remove: _e
  };
}
const Tt = "_thread_1layy_9", Rt = "_head_1layy_28", Pt = "_headTitle_1layy_37", Ot = "_headCount_1layy_43", qt = "_list_1layy_54", Gt = "_row_1layy_61", Wt = "_isReply_1layy_73", zt = "_pending_1layy_80", Kt = "_avatar_1layy_84", Ht = "_avatarGhost_1layy_98", Vt = "_body_1layy_103", Ut = "_meta_1layy_108", Qt = "_author_1layy_116", Yt = "_dept_1layy_122", Jt = "_time_1layy_130", Zt = "_text_1layy_135", ea = "_textDeleted_1layy_143", ta = "_acts_1layy_148", aa = "_act_1layy_148", na = "_actDanger_1layy_169", oa = "_empty_1layy_175", sa = "_error_1layy_182", ra = "_skeleton_1layy_196", ca = "_more_1layy_219", la = "_foot_1layy_245", ia = "_composer_1layy_252", da = "_composerInput_1layy_261", _a = "_composerActions_1layy_284", ma = "_btn_1layy_291", ua = "_btnPrimary_1layy_301", pa = "_btnGhost_1layy_310", p = {
  thread: Tt,
  head: Rt,
  headTitle: Pt,
  headCount: Ot,
  list: qt,
  row: Gt,
  isReply: Wt,
  pending: zt,
  avatar: Kt,
  avatarGhost: Ht,
  body: Vt,
  meta: Ut,
  author: Qt,
  dept: Yt,
  time: Jt,
  text: Zt,
  textDeleted: ea,
  acts: ta,
  act: aa,
  actDanger: na,
  empty: oa,
  error: sa,
  skeleton: ra,
  more: ca,
  foot: la,
  composer: ia,
  composerInput: da,
  composerActions: _a,
  btn: ma,
  btnPrimary: ua,
  btnGhost: pa
}, Ge = ["#3B82F6", "#7C3AED", "#10B981", "#F97316", "#EF4444", "#0EA5E9"];
function Ea(t) {
  let a = 0;
  for (let n = 0; n < t.length; n += 1) a = (a * 31 + t.charCodeAt(n)) % 997;
  return Ge[a % Ge.length];
}
function fa(t) {
  const a = t.trim();
  return a ? a[0].toUpperCase() : "?";
}
const We = 6e4, ze = 36e5, Ke = 864e5, ba = 6048e5;
function ya(t) {
  const a = new Date(t).getTime();
  if (Number.isNaN(a)) return "";
  const n = Date.now() - a;
  if (n < We) return "방금";
  if (n < ze) return `${Math.floor(n / We)}분 전`;
  if (n < Ke) return `${Math.floor(n / ze)}시간 전`;
  if (n < ba) return `${Math.floor(n / Ke)}일 전`;
  const o = new Date(a), r = (s) => s < 10 ? `0${s}` : String(s);
  return `${o.getFullYear()}.${r(o.getMonth() + 1)}.${r(o.getDate())}`;
}
function je({
  placeholder: t,
  submitLabel: a,
  autoFocus: n,
  initialValue: o,
  onSubmit: r,
  onCancel: s
}) {
  const [l, d] = A(o != null ? o : ""), [c, i] = A(!1), m = J(null);
  Z(() => {
    n && m.current && m.current.focus();
  }, [n]);
  const _ = async () => {
    const u = l.trim();
    if (!u || c) return;
    i(!0);
    const f = await r(u);
    i(!1), f && d("");
  };
  return /* @__PURE__ */ e.createElement("div", { className: p.composer }, /* @__PURE__ */ e.createElement(
    "textarea",
    {
      ref: m,
      className: p.composerInput,
      rows: o === void 0 ? 2 : 3,
      placeholder: t,
      value: l,
      disabled: c,
      onChange: (u) => d(u.target.value),
      onKeyDown: (u) => {
        const f = u.nativeEvent.isComposing;
        u.key === "Enter" && !u.shiftKey && !f && (u.preventDefault(), _()), u.key === "Escape" && s && (u.nativeEvent.stopPropagation(), s());
      }
    }
  ), /* @__PURE__ */ e.createElement("div", { className: p.composerActions }, s && /* @__PURE__ */ e.createElement(
    "button",
    {
      type: "button",
      className: `${p.btn} ${p.btnGhost}`,
      onClick: s,
      disabled: c
    },
    "취소"
  ), /* @__PURE__ */ e.createElement(
    "button",
    {
      type: "button",
      className: `${p.btn} ${p.btnPrimary}`,
      onClick: () => void _(),
      disabled: c || !l.trim()
    },
    c ? "보내는 중…" : a
  )));
}
function ga({
  item: t,
  replying: a,
  editing: n,
  onReply: o,
  onEdit: r,
  onSubmitReply: s,
  onSubmitEdit: l,
  onDelete: d,
  onCancel: c
}) {
  var u, f;
  const i = Bt(t), m = i ? ` ${p.isReply}` : "";
  if (t.deleted)
    return /* @__PURE__ */ e.createElement("div", { className: `${p.row}${m}` }, /* @__PURE__ */ e.createElement("span", { className: `${p.avatar} ${p.avatarGhost}` }, "·"), /* @__PURE__ */ e.createElement("div", { className: p.body }, /* @__PURE__ */ e.createElement("div", { className: `${p.text} ${p.textDeleted}` }, "삭제된 댓글입니다")));
  const _ = (u = t.authorName) != null ? u : "anonymous";
  return /* @__PURE__ */ e.createElement("div", { className: `${p.row}${m}${t.pending ? ` ${p.pending}` : ""}` }, /* @__PURE__ */ e.createElement("span", { className: p.avatar, style: { background: Ea(_) } }, fa(_)), /* @__PURE__ */ e.createElement("div", { className: p.body }, /* @__PURE__ */ e.createElement("div", { className: p.meta }, /* @__PURE__ */ e.createElement("span", { className: p.author }, _), t.dept && /* @__PURE__ */ e.createElement("span", { className: p.dept }, t.dept), /* @__PURE__ */ e.createElement("span", { className: p.time }, ya(t.createdAt)), t.updatedAt && /* @__PURE__ */ e.createElement("span", { className: p.time }, "(수정됨)")), n ? /* @__PURE__ */ e.createElement(
    je,
    {
      placeholder: "댓글을 수정합니다",
      submitLabel: "수정",
      autoFocus: !0,
      initialValue: (f = t.content) != null ? f : "",
      onSubmit: l,
      onCancel: c
    }
  ) : /* @__PURE__ */ e.createElement("div", { className: p.text }, t.content), !n && !t.pending && /* @__PURE__ */ e.createElement("div", { className: p.acts }, !i && /* @__PURE__ */ e.createElement("button", { type: "button", className: p.act, onClick: o }, "답글"), t.mine && /* @__PURE__ */ e.createElement("button", { type: "button", className: p.act, onClick: r }, "수정"), t.mine && /* @__PURE__ */ e.createElement(
    "button",
    {
      type: "button",
      className: `${p.act} ${p.actDanger}`,
      onClick: d
    },
    "삭제"
  )), a && /* @__PURE__ */ e.createElement(
    je,
    {
      placeholder: `${_} 님에게 답글`,
      submitLabel: "답글 등록",
      autoFocus: !0,
      onSubmit: s,
      onCancel: c
    }
  )));
}
function Jc({
  targetType: t,
  targetId: a,
  onCountChange: n,
  autoFocus: o,
  showHeader: r = !0,
  className: s,
  style: l
}) {
  const { items: d, initialLoading: c, loading: i, error: m, count: _, hasMore: u, loadMore: f, reload: y, add: E, edit: h, remove: w } = Mt(t, a), [X, T] = A(null), [O, q] = A(null);
  Z(() => {
    T(null), q(null);
  }, [t, a]);
  const V = J(n);
  return V.current = n, Z(() => {
    !c && V.current && V.current(_);
  }, [_, c]), /* @__PURE__ */ e.createElement("div", { className: s ? `${p.thread} ${s}` : p.thread, style: l }, r && /* @__PURE__ */ e.createElement("div", { className: p.head }, /* @__PURE__ */ e.createElement("span", { className: p.headTitle }, "댓글"), /* @__PURE__ */ e.createElement("span", { className: p.headCount }, _)), /* @__PURE__ */ e.createElement("div", { className: p.list }, c && /* @__PURE__ */ e.createElement("div", { className: p.skeleton }, /* @__PURE__ */ e.createElement("span", null), /* @__PURE__ */ e.createElement("span", null), /* @__PURE__ */ e.createElement("span", null)), m && /* @__PURE__ */ e.createElement("div", { className: p.error }, /* @__PURE__ */ e.createElement("span", null, m), /* @__PURE__ */ e.createElement(
    "button",
    {
      type: "button",
      className: `${p.btn} ${p.btnGhost}`,
      onClick: y
    },
    "다시 시도"
  )), !c && !m && d.length === 0 && /* @__PURE__ */ e.createElement("div", { className: p.empty }, "첫 댓글을 남겨 보세요."), d.map((C) => /* @__PURE__ */ e.createElement(
    ga,
    {
      key: C.id,
      item: C,
      replying: X === C.id,
      editing: O === C.id,
      onReply: () => {
        q(null), T(C.id);
      },
      onEdit: () => {
        T(null), q(C.id);
      },
      onCancel: () => {
        T(null), q(null);
      },
      onSubmitReply: async (_e) => {
        const b = await E(_e, C.id);
        return b && T(null), b;
      },
      onSubmitEdit: async (_e) => {
        const b = await h(C.id, _e);
        return b && q(null), b;
      },
      onDelete: () => {
        w(C.id);
      }
    }
  )), u && /* @__PURE__ */ e.createElement("button", { type: "button", className: p.more, onClick: f, disabled: i }, i ? "불러오는 중…" : "이전 댓글 더 보기")), /* @__PURE__ */ e.createElement("div", { className: p.foot }, /* @__PURE__ */ e.createElement(
    je,
    {
      placeholder: "댓글을 입력하세요 (Enter 전송, Shift+Enter 줄바꿈)",
      submitLabel: "등록",
      autoFocus: o,
      onSubmit: (C) => E(C)
    }
  )));
}
function Zc(t, a) {
  const [n, o] = A({}), [r, s] = A(!1), [l, d] = A(0), c = a.join(",");
  return Z(() => {
    const i = c ? c.split(",") : [];
    if (i.length === 0) {
      o({});
      return;
    }
    const m = new AbortController();
    return s(!0), Lt(t, i, m.signal).then((_) => {
      m.signal.aborted || o(_);
    }).catch(() => {
      m.signal.aborted || o({});
    }).finally(() => {
      m.signal.aborted || s(!1);
    }), () => m.abort();
  }, [t, c, l]), {
    counts: n,
    loading: r,
    reload: () => d((i) => i + 1)
  };
}
const ha = "_card_epi3f_1", va = "_header_epi3f_8", ka = "_headerNoDivider_epi3f_13", Na = "_body_epi3f_17", Aa = "_paddingSm_epi3f_22", wa = "_paddingMd_epi3f_26", $a = "_paddingLg_epi3f_30", G = {
  card: ha,
  header: va,
  headerNoDivider: ka,
  body: Na,
  paddingSm: Aa,
  paddingMd: wa,
  paddingLg: $a
};
function el({
  children: t,
  header: a,
  padding: n = "md",
  radius: o,
  headerDivider: r = !0,
  headerBackground: s,
  headerPadding: l,
  headerBorderColor: d,
  className: c
}) {
  const i = typeof n == "number" ? "" : n === "sm" ? G.paddingSm : n === "lg" ? G.paddingLg : G.paddingMd, m = typeof n == "number" ? { padding: n } : void 0, _ = c ? `${G.card} ${c}` : G.card, u = r ? G.header : `${G.header} ${G.headerNoDivider}`, f = {
    ...s !== void 0 ? { background: s } : {},
    ...l !== void 0 ? { padding: l } : {},
    ...d !== void 0 ? { borderBottomColor: d } : {}
  };
  return /* @__PURE__ */ e.createElement("div", { className: _, style: o !== void 0 ? { borderRadius: o } : void 0 }, a && /* @__PURE__ */ e.createElement("div", { className: u, style: f }, a), /* @__PURE__ */ e.createElement("div", { className: `${G.body} ${i}`, style: m }, t));
}
const xa = "_horizontal_mkht7_1", Xa = "_vertical_mkht7_8", He = {
  horizontal: xa,
  vertical: Xa
};
function tl({ orientation: t = "horizontal", spacing: a = 0, color: n }) {
  const o = t === "vertical";
  return /* @__PURE__ */ e.createElement(
    "div",
    {
      className: o ? He.vertical : He.horizontal,
      style: {
        ...o ? { marginLeft: a, marginRight: a } : { marginTop: a, marginBottom: a },
        ...n !== void 0 ? { backgroundColor: n } : {}
      },
      role: "separator",
      "aria-orientation": t
    }
  );
}
const Ca = "_root_nvy8t_1", Sa = "_icon_nvy8t_7", Ba = "_iconBadge_nvy8t_15", Fa = "_titleGroup_nvy8t_25", Ia = "_title_nvy8t_25", ja = "_subtitle_nvy8t_41", La = "_trailing_nvy8t_49", Da = "_closeButton_nvy8t_58", Q = {
  root: Ca,
  icon: Sa,
  iconBadge: Ba,
  titleGroup: Fa,
  title: Ia,
  subtitle: ja,
  trailing: La,
  closeButton: Da
};
function al({
  icon: t,
  iconColor: a,
  iconBadge: n = !1,
  iconBadgeColor: o = "#3b82f6",
  iconBadgeGradient: r,
  iconBadgeSize: s,
  title: l,
  titleWeight: d,
  titleSize: c,
  subtitle: i,
  subtitleColor: m,
  subtitleSize: _,
  trailing: u,
  onClose: f
}) {
  const y = {
    ...d !== void 0 ? { fontWeight: d } : {},
    ...c !== void 0 ? { fontSize: c } : {}
  }, E = {
    ...m !== void 0 ? { color: m } : {},
    ..._ !== void 0 ? { fontSize: _ } : {}
  };
  return /* @__PURE__ */ e.createElement("div", { className: Q.root }, t && n && /* @__PURE__ */ e.createElement(
    "span",
    {
      className: Q.iconBadge,
      style: {
        ...r ? { background: `linear-gradient(135deg, ${r[0]}, ${r[1]})`, color: "#fff" } : { backgroundColor: `${o}1A`, color: o },
        ...s !== void 0 ? { width: s, height: s } : {}
      }
    },
    t
  ), t && !n && /* @__PURE__ */ e.createElement("span", { className: Q.icon, style: a !== void 0 ? { color: a } : void 0 }, t), /* @__PURE__ */ e.createElement("div", { className: Q.titleGroup }, /* @__PURE__ */ e.createElement("span", { className: Q.title, style: y }, l), i && /* @__PURE__ */ e.createElement("span", { className: Q.subtitle, style: E }, i)), u && /* @__PURE__ */ e.createElement("div", { className: Q.trailing }, u), f && /* @__PURE__ */ e.createElement(
    "button",
    {
      type: "button",
      className: Q.closeButton,
      onClick: f,
      "aria-label": "닫기"
    },
    "×"
  ));
}
const Ma = "_badge_19977_1", Ta = {
  badge: Ma
};
function nl({
  size: t = 32,
  gradient: a = ["#7C3AED", "#3B82F6"],
  icon: n
}) {
  const o = t * 0.55;
  return /* @__PURE__ */ e.createElement(
    "span",
    {
      className: Ta.badge,
      style: {
        width: t,
        height: t,
        background: `linear-gradient(135deg, ${a[0]}, ${a[1]})`
      }
    },
    n != null ? n : /* @__PURE__ */ e.createElement("svg", { width: o, height: o, viewBox: "0 0 24 24", fill: "#fff" }, /* @__PURE__ */ e.createElement("path", { d: "M12 2 L13.5 10.5 L22 12 L13.5 13.5 L12 22 L10.5 13.5 L2 12 L10.5 10.5 Z" }))
  );
}
const Ra = "_wrapper_ccmq2_1", Pa = "_image_ccmq2_8", Oa = "_fallback_ccmq2_16", qa = "_statusDot_ccmq2_29", Ae = {
  wrapper: Ra,
  image: Pa,
  fallback: Oa,
  statusDot: qa
}, Ga = {
  on: "#22C55E",
  away: "#F59E0B",
  off: "#94A3B8"
};
function Wa(t) {
  const a = t == null ? void 0 : t.trim();
  return a ? Array.from(a)[0].toUpperCase() : "";
}
const Ce = [
  "#EF4444",
  "#F97316",
  "#F59E0B",
  "#10B981",
  "#0EA5E9",
  "#3B82F6",
  "#6366F1",
  "#8B5CF6",
  "#D946EF",
  "#EC4899"
];
function za(t) {
  const a = t == null ? void 0 : t.trim();
  if (!a) return Ce[5];
  let n = 0;
  for (let o = 0; o < a.length; o += 1)
    n = n * 31 + a.charCodeAt(o) | 0;
  return Ce[Math.abs(n) % Ce.length];
}
function lt({
  src: t,
  fallbackText: a,
  alt: n,
  size: o = 32,
  statusDot: r,
  color: s,
  ring: l = !1,
  ringColor: d = "#fff"
}) {
  var _;
  const [c, i] = A(), m = !!t && c !== t;
  return /* @__PURE__ */ e.createElement(
    "span",
    {
      className: Ae.wrapper,
      style: {
        width: o,
        height: o,
        ...l ? { boxShadow: `0 0 0 2px ${d}` } : {}
      }
    },
    m ? /* @__PURE__ */ e.createElement(
      "img",
      {
        className: Ae.image,
        src: t,
        alt: (_ = n != null ? n : a) != null ? _ : "",
        onError: () => i(t)
      }
    ) : /* @__PURE__ */ e.createElement(
      "span",
      {
        className: Ae.fallback,
        style: {
          backgroundColor: s != null ? s : za(a),
          fontSize: Math.max(10, o * 0.45)
        }
      },
      Wa(a)
    ),
    r && /* @__PURE__ */ e.createElement(
      "span",
      {
        className: Ae.statusDot,
        style: {
          backgroundColor: Ga[r],
          width: Math.max(8, o * 0.28),
          height: Math.max(8, o * 0.28)
        }
      }
    )
  );
}
const Ka = "_stack_y8phg_1", Ha = "_item_y8phg_6", Va = "_overflow_y8phg_18", we = {
  stack: Ka,
  item: Ha,
  overflow: Va
};
function ol({
  avatars: t,
  max: a = 4,
  size: n = 32
}) {
  const o = t.slice(0, a), r = t.length - o.length;
  return /* @__PURE__ */ e.createElement("span", { className: we.stack }, o.map((s, l) => /* @__PURE__ */ e.createElement("span", { key: l, className: we.item, style: { zIndex: o.length - l } }, /* @__PURE__ */ e.createElement(lt, { src: s.src, alt: s.alt, fallbackText: s.fallbackText, size: n }))), r > 0 && /* @__PURE__ */ e.createElement("span", { className: we.item, style: { zIndex: 0 } }, /* @__PURE__ */ e.createElement(
    "span",
    {
      className: we.overflow,
      style: { width: n, height: n, fontSize: Math.max(10, n * 0.36) }
    },
    "+",
    r
  )));
}
const Ua = "_badge_1mjda_1", Qa = "_pill_1mjda_15", Ya = "_dot_1mjda_19", Ja = "_dotPulse_1mjda_26", Za = "_outline_1mjda_40", en = "_soft_1mjda_46", pe = {
  badge: Ua,
  pill: Qa,
  dot: Ya,
  dotPulse: Ja,
  "ax-badge-pulse": "_ax-badge-pulse_1mjda_1",
  default: "_default_1mjda_35",
  outline: Za,
  soft: en
};
function sl({
  label: t,
  variant: a = "default",
  color: n,
  background: o,
  textColor: r,
  shape: s = "rounded",
  dot: l = !1,
  dotColor: d,
  dotPulse: c = !1,
  border: i = !1,
  borderColor: m = "currentColor"
}) {
  var y;
  const _ = {};
  n && (a === "default" ? (_.backgroundColor = n, _.color = "#fff") : a === "outline" ? (_.borderColor = n, _.color = n) : (_.backgroundColor = `${n}1A`, _.color = n)), o !== void 0 && (_.backgroundColor = o), r !== void 0 && (_.color = r), i && (_.borderColor = m);
  const u = [
    pe.badge,
    pe[a],
    s === "pill" ? pe.pill : ""
  ].filter(Boolean).join(" "), f = [pe.dot, c ? pe.dotPulse : ""].filter(Boolean).join(" ");
  return /* @__PURE__ */ e.createElement("span", { className: u, style: _ }, l && /* @__PURE__ */ e.createElement("span", { className: f, style: { backgroundColor: d != null ? d : (y = r != null ? r : n) != null ? y : "currentColor" } }), t);
}
const tn = "_row_1k2ap_1", an = "_reply_1k2ap_7", nn = "_avatar_1k2ap_12", on = "_avatarImage_1k2ap_25", sn = "_avatarFallback_1k2ap_32", rn = "_body_1k2ap_44", cn = "_headerLine_1k2ap_49", ln = "_author_1k2ap_56", dn = "_meta_1k2ap_62", _n = "_text_1k2ap_67", mn = "_actionsRow_1k2ap_74", un = "_actionBtn_1k2ap_81", F = {
  row: tn,
  reply: an,
  avatar: nn,
  avatarImage: on,
  avatarFallback: sn,
  body: rn,
  headerLine: cn,
  author: ln,
  meta: dn,
  text: _n,
  actionsRow: mn,
  actionBtn: un
};
function pn(t) {
  const a = t.trim();
  return a ? a[0].toUpperCase() : "";
}
function rl({
  avatarSrc: t,
  author: a,
  meta: n,
  text: o,
  likeCount: r,
  replyCount: s,
  isReply: l = !1,
  onLikeClick: d,
  onReplyClick: c
}) {
  const [i, m] = A(!1), _ = !!t && !i;
  return /* @__PURE__ */ e.createElement("div", { className: `${F.row} ${l ? F.reply : ""}` }, /* @__PURE__ */ e.createElement("span", { className: F.avatar }, _ ? /* @__PURE__ */ e.createElement(
    "img",
    {
      className: F.avatarImage,
      src: t,
      alt: a,
      onError: () => m(!0)
    }
  ) : /* @__PURE__ */ e.createElement("span", { className: F.avatarFallback }, pn(a))), /* @__PURE__ */ e.createElement("div", { className: F.body }, /* @__PURE__ */ e.createElement("div", { className: F.headerLine }, /* @__PURE__ */ e.createElement("span", { className: F.author }, a), n && /* @__PURE__ */ e.createElement("span", { className: F.meta }, n)), /* @__PURE__ */ e.createElement("div", { className: F.text }, o), /* @__PURE__ */ e.createElement("div", { className: F.actionsRow }, /* @__PURE__ */ e.createElement("button", { type: "button", className: F.actionBtn, onClick: d }, /* @__PURE__ */ e.createElement("svg", { width: "14", height: "14", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }, /* @__PURE__ */ e.createElement("path", { d: "M14 9V5a3 3 0 0 0-3-3l-4 9v11h11.28a2 2 0 0 0 2-1.7l1.38-9a2 2 0 0 0-2-2.3zM7 22H4a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2h3" })), typeof r == "number" && /* @__PURE__ */ e.createElement("span", null, r)), /* @__PURE__ */ e.createElement("button", { type: "button", className: F.actionBtn, onClick: c }, /* @__PURE__ */ e.createElement("svg", { width: "14", height: "14", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }, /* @__PURE__ */ e.createElement("path", { d: "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" })), typeof s == "number" && /* @__PURE__ */ e.createElement("span", null, s)))));
}
const En = "_wrapper_79n51_1", fn = {
  wrapper: En
}, bn = {
  pdf: { label: "PDF", color: "#B91C1C", bg: "#FEF2F2" },
  doc: { label: "DOC", color: "#1D4ED8", bg: "#EFF6FF" },
  docx: { label: "DOC", color: "#1D4ED8", bg: "#EFF6FF" },
  xls: { label: "XLS", color: "#166534", bg: "#F0FDF4" },
  xlsx: { label: "XLS", color: "#166534", bg: "#F0FDF4" },
  ppt: { label: "PPT", color: "#92400E", bg: "#FFFBEB" },
  pptx: { label: "PPT", color: "#92400E", bg: "#FFFBEB" },
  zip: { label: "ZIP", color: "#64748B", bg: "#F1F5F9" },
  rar: { label: "ZIP", color: "#64748B", bg: "#F1F5F9" },
  "7z": { label: "ZIP", color: "#64748B", bg: "#F1F5F9" },
  jpg: { label: "IMG", color: "#3B82F6", bg: "#EFF6FF" },
  jpeg: { label: "IMG", color: "#3B82F6", bg: "#EFF6FF" },
  png: { label: "IMG", color: "#3B82F6", bg: "#EFF6FF" },
  gif: { label: "IMG", color: "#3B82F6", bg: "#EFF6FF" },
  svg: { label: "IMG", color: "#3B82F6", bg: "#EFF6FF" },
  mp4: { label: "VID", color: "#334155", bg: "#F1F5F9" },
  mov: { label: "VID", color: "#334155", bg: "#F1F5F9" },
  avi: { label: "VID", color: "#334155", bg: "#F1F5F9" },
  txt: { label: "TXT", color: "#334155", bg: "#F8FAFC" }
}, yn = { label: "FILE", color: "#64748B", bg: "#F1F5F9" };
function gn({ ext: t, size: a = 32 }) {
  var l;
  const n = t.trim().toLowerCase().replace(/^\./, ""), { label: o, color: r, bg: s } = (l = bn[n]) != null ? l : yn;
  return /* @__PURE__ */ e.createElement(
    "span",
    {
      className: fn.wrapper,
      style: {
        width: a,
        height: a,
        backgroundColor: s,
        color: r,
        fontSize: Math.max(8, a * 0.26)
      }
    },
    o
  );
}
const hn = "_chip_1jhj8_1", vn = "_clickable_1jhj8_12", kn = "_icon_1jhj8_21", Nn = "_info_1jhj8_26", An = "_name_1jhj8_33", wn = "_size_1jhj8_42", $n = "_chipError_1jhj8_48", xn = "_chipDone_1jhj8_53", Xn = "_status_1jhj8_57", Cn = "_statusError_1jhj8_66", Sn = "_statusDone_1jhj8_67", Bn = "_statusIcon_1jhj8_69", Fn = "_statusLabel_1jhj8_71", In = "_progressTrack_1jhj8_78", jn = "_progressFill_1jhj8_88", Ln = "_actionBtn_1jhj8_96", N = {
  chip: hn,
  clickable: vn,
  icon: kn,
  info: Nn,
  name: An,
  size: wn,
  chipError: $n,
  chipDone: xn,
  status: Xn,
  statusError: Cn,
  statusDone: Sn,
  statusIcon: Bn,
  statusLabel: Fn,
  progressTrack: In,
  progressFill: jn,
  actionBtn: Ln
};
function cl({
  name: t,
  ext: a,
  size: n,
  onRemove: o,
  downloadable: r = !1,
  onClick: s,
  status: l,
  statusText: d,
  percent: c
}) {
  const i = l === "error" ? N.chipError : l === "done" ? N.chipDone : "";
  return /* @__PURE__ */ e.createElement(
    "div",
    {
      className: `${N.chip} ${s ? N.clickable : ""} ${i}`,
      onClick: s,
      title: l === "error" ? d : void 0
    },
    a && /* @__PURE__ */ e.createElement("span", { className: N.icon }, /* @__PURE__ */ e.createElement(gn, { ext: a, size: 28 })),
    /* @__PURE__ */ e.createElement("span", { className: N.info }, /* @__PURE__ */ e.createElement("span", { className: N.name }, t), d ? /* @__PURE__ */ e.createElement("span", { className: `${N.status} ${l === "error" ? N.statusError : l === "done" ? N.statusDone : ""}` }, l === "error" && /* @__PURE__ */ e.createElement("svg", { className: N.statusIcon, width: "11", height: "11", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2.4", strokeLinecap: "round" }, /* @__PURE__ */ e.createElement("circle", { cx: "12", cy: "12", r: "9" }), /* @__PURE__ */ e.createElement("path", { d: "M12 7v6M12 16.5v.01" })), l === "done" && /* @__PURE__ */ e.createElement("svg", { className: N.statusIcon, width: "11", height: "11", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2.6", strokeLinecap: "round", strokeLinejoin: "round" }, /* @__PURE__ */ e.createElement("path", { d: "M4 12.5l5 5L20 6.5" })), /* @__PURE__ */ e.createElement("span", { className: N.statusLabel }, d)) : n ? /* @__PURE__ */ e.createElement("span", { className: N.size }, n) : null, l === "processing" && /* @__PURE__ */ e.createElement("span", { className: N.progressTrack }, /* @__PURE__ */ e.createElement("span", { className: N.progressFill, style: { width: `${Math.max(0, Math.min(100, c != null ? c : 0))}%` } }))),
    r ? /* @__PURE__ */ e.createElement(
      "button",
      {
        type: "button",
        className: N.actionBtn,
        "aria-label": "내려받기",
        onClick: (m) => m.stopPropagation()
      },
      /* @__PURE__ */ e.createElement("svg", { width: "14", height: "14", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }, /* @__PURE__ */ e.createElement("path", { d: "M12 3v12M7 10l5 5 5-5M4 21h16" }))
    ) : o ? /* @__PURE__ */ e.createElement(
      "button",
      {
        type: "button",
        className: N.actionBtn,
        "aria-label": "삭제",
        onClick: (m) => {
          m.stopPropagation(), o();
        }
      },
      /* @__PURE__ */ e.createElement("svg", { width: "14", height: "14", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }, /* @__PURE__ */ e.createElement("path", { d: "M18 6L6 18M6 6l12 12" }))
    ) : null
  );
}
const Dn = "_list_1yxwc_1", Mn = "_row_1yxwc_6", Tn = "_inline_1yxwc_15", Rn = "_label_1yxwc_22", Pn = "_value_1yxwc_29", On = "_stacked_1yxwc_35", qn = "_bold_1yxwc_51", oe = {
  list: Dn,
  row: Mn,
  inline: Tn,
  label: Rn,
  value: Pn,
  stacked: On,
  bold: qn
};
function ll({
  rows: t,
  direction: a = "inline"
}) {
  return /* @__PURE__ */ e.createElement("div", { className: `${oe.list} ${oe[a]}` }, t.map((n, o) => /* @__PURE__ */ e.createElement("div", { key: o, className: oe.row }, /* @__PURE__ */ e.createElement("span", { className: oe.label }, n.label), /* @__PURE__ */ e.createElement("span", { className: `${oe.value} ${n.bold ? oe.bold : ""}` }, n.value))));
}
const Gn = "_container_2r163_1", Wn = "_row_2r163_5", zn = "_clickable_2r163_12", Kn = "_leading_2r163_20", Hn = "_main_2r163_26", Vn = "_titleLine_2r163_34", Un = "_title_2r163_34", Qn = "_tags_2r163_50", Yn = "_meta_2r163_57", Jn = "_actions_2r163_62", Zn = "_expandable_2r163_69", M = {
  container: Gn,
  row: Wn,
  clickable: zn,
  leading: Kn,
  main: Hn,
  titleLine: Vn,
  title: Un,
  tags: Qn,
  meta: Yn,
  actions: Jn,
  expandable: Zn
};
function il({
  leading: t,
  title: a,
  meta: n,
  tags: o,
  actions: r,
  expandableContent: s,
  expanded: l = !1,
  onClick: d
}) {
  return /* @__PURE__ */ e.createElement("div", { className: M.container }, /* @__PURE__ */ e.createElement("div", { className: `${M.row} ${d ? M.clickable : ""}`, onClick: d }, t && /* @__PURE__ */ e.createElement("div", { className: M.leading }, t), /* @__PURE__ */ e.createElement("div", { className: M.main }, /* @__PURE__ */ e.createElement("div", { className: M.titleLine }, /* @__PURE__ */ e.createElement("span", { className: M.title }, a), o && /* @__PURE__ */ e.createElement("span", { className: M.tags }, o)), n && /* @__PURE__ */ e.createElement("div", { className: M.meta }, n)), r && /* @__PURE__ */ e.createElement("div", { className: M.actions, onClick: (c) => c.stopPropagation() }, r)), l && s && /* @__PURE__ */ e.createElement("div", { className: M.expandable }, s));
}
const eo = "_row_xzgny_1", to = "_info_xzgny_8", ao = "_name_xzgny_16", no = "_subtitle_xzgny_25", oo = "_status_xzgny_33", Ee = {
  row: eo,
  info: to,
  name: ao,
  subtitle: no,
  status: oo
};
function dl({
  avatarSrc: t,
  name: a,
  subtitle: n,
  status: o,
  statusColor: r = "#64748B",
  statusBg: s = "#F1F5F9"
}) {
  return /* @__PURE__ */ e.createElement("div", { className: Ee.row }, /* @__PURE__ */ e.createElement(lt, { src: t, fallbackText: a, size: 36 }), /* @__PURE__ */ e.createElement("div", { className: Ee.info }, /* @__PURE__ */ e.createElement("span", { className: Ee.name }, a), n && /* @__PURE__ */ e.createElement("span", { className: Ee.subtitle }, n)), o && /* @__PURE__ */ e.createElement(
    "span",
    {
      className: Ee.status,
      style: { color: r, backgroundColor: s }
    },
    o
  ));
}
const so = "_row_qoxwr_1", ro = "_clickable_qoxwr_9", co = "_rank_qoxwr_17", lo = "_title_qoxwr_25", io = "_trailing_qoxwr_36", fe = {
  row: so,
  clickable: ro,
  rank: co,
  title: lo,
  trailing: io
}, _o = {
  1: "#F59E0B",
  2: "#94A3B8",
  3: "#B45309"
};
function _l({
  rank: t,
  rankColor: a,
  title: n,
  trailingText: o,
  onClick: r
}) {
  var l;
  const s = (l = a != null ? a : _o[t]) != null ? l : "#64748B";
  return /* @__PURE__ */ e.createElement("div", { className: `${fe.row} ${r ? fe.clickable : ""}`, onClick: r }, /* @__PURE__ */ e.createElement("span", { className: fe.rank, style: { color: s } }, t), /* @__PURE__ */ e.createElement("span", { className: fe.title }, n), o && /* @__PURE__ */ e.createElement("span", { className: fe.trailing }, o));
}
const mo = "_badge_1qibj_1", uo = "_sm_1qibj_11", po = "_md_1qibj_16", Eo = "_overdue_1qibj_21", fo = "_warning_1qibj_26", bo = "_progress_1qibj_31", yo = "_success_1qibj_36", go = "_info_1qibj_41", ho = "_neutral_1qibj_46", Se = {
  badge: mo,
  sm: uo,
  md: po,
  overdue: Eo,
  warning: fo,
  progress: bo,
  success: yo,
  info: go,
  neutral: ho
};
function ml({
  label: t,
  tone: a = "neutral",
  size: n = "md",
  background: o,
  textColor: r
}) {
  const s = {};
  return o !== void 0 && (s.backgroundColor = o), r !== void 0 && (s.color = r), /* @__PURE__ */ e.createElement("span", { className: `${Se.badge} ${Se[a]} ${Se[n]}`, style: s }, t);
}
const vo = "_wrapper_14p14_1", ko = "_avatar_14p14_11", No = "_body_14p14_21", Ao = "_message_14p14_26", wo = "_dots_14p14_32", $o = "_dot_14p14_32", xo = "_action_14p14_70", Xo = "_actionIcon_14p14_89", Co = "_gradientWrapper_14p14_95", So = "_bareIcon_14p14_100", Bo = "_ctaButton_14p14_109", $ = {
  wrapper: vo,
  avatar: ko,
  body: No,
  message: Ao,
  dots: wo,
  dot: $o,
  action: xo,
  actionIcon: Xo,
  gradientWrapper: Co,
  bareIcon: So,
  ctaButton: Bo
};
function Ve() {
  return /* @__PURE__ */ e.createElement("svg", { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M8 1.5l1.4 3.9L13.3 6.8l-3.9 1.4L8 12.1l-1.4-3.9L2.7 6.8l3.9-1.4L8 1.5z",
      fill: "currentColor"
    }
  ));
}
function Ue() {
  return /* @__PURE__ */ e.createElement("svg", { width: "14", height: "14", viewBox: "0 0 14 14", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M3 7h8M7.5 3.5L11 7l-3.5 3.5",
      stroke: "currentColor",
      strokeWidth: "1.6",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  ));
}
function ul({
  message: t,
  accentColor: a = "#7C3AED",
  buttonLabel: n,
  buttonIcon: o,
  onAction: r,
  phase: s = "complete",
  variant: l = "card",
  gradientColors: d = ["#EEF4FF", "#F3EEFF"]
}) {
  const c = l === "gradient-cta";
  return /* @__PURE__ */ e.createElement(
    "div",
    {
      className: [$.wrapper, c ? $.gradientWrapper : ""].join(" "),
      style: c ? { borderColor: `${a}33`, background: `linear-gradient(135deg, ${d[0]}, ${d[1]})` } : { borderColor: `${a}33` }
    },
    c ? /* @__PURE__ */ e.createElement("span", { className: $.bareIcon, style: { color: a } }, /* @__PURE__ */ e.createElement(Ve, null)) : /* @__PURE__ */ e.createElement(
      "span",
      {
        className: $.avatar,
        style: { backgroundColor: `${a}1A`, color: a }
      },
      /* @__PURE__ */ e.createElement(Ve, null)
    ),
    /* @__PURE__ */ e.createElement("div", { className: $.body }, s === "loading" ? /* @__PURE__ */ e.createElement("span", { className: $.dots }, /* @__PURE__ */ e.createElement("span", { className: $.dot, style: { backgroundColor: a } }), /* @__PURE__ */ e.createElement("span", { className: $.dot, style: { backgroundColor: a } }), /* @__PURE__ */ e.createElement("span", { className: $.dot, style: { backgroundColor: a } })) : /* @__PURE__ */ e.createElement("span", { className: $.message, style: c ? { color: a } : void 0 }, t)),
    n && r && (c ? /* @__PURE__ */ e.createElement(
      "button",
      {
        type: "button",
        className: $.ctaButton,
        style: { backgroundColor: a },
        onClick: r
      },
      /* @__PURE__ */ e.createElement("span", null, n),
      /* @__PURE__ */ e.createElement("span", { className: $.actionIcon }, o === void 0 ? /* @__PURE__ */ e.createElement(Ue, null) : o)
    ) : /* @__PURE__ */ e.createElement(
      "button",
      {
        type: "button",
        className: $.action,
        style: { color: a },
        onClick: r
      },
      /* @__PURE__ */ e.createElement("span", null, n),
      /* @__PURE__ */ e.createElement("span", { className: $.actionIcon }, o === void 0 ? /* @__PURE__ */ e.createElement(Ue, null) : o)
    ))
  );
}
const Fo = "_wrapper_68zkp_1", Io = "_bordered_68zkp_13", jo = "_compact_68zkp_17", Lo = "_icon_68zkp_23", Do = "_title_68zkp_31", Mo = "_description_68zkp_38", To = "_action_68zkp_46", ee = {
  wrapper: Fo,
  bordered: Io,
  compact: jo,
  icon: Lo,
  title: Do,
  description: Mo,
  action: To
};
function Ro() {
  return /* @__PURE__ */ e.createElement(
    "svg",
    {
      width: "40",
      height: "40",
      viewBox: "0 0 40 40",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M6 15L20 8l14 7-14 7-14-7z",
        stroke: "#94A3B8",
        strokeWidth: "1.6",
        strokeLinejoin: "round"
      }
    ),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M6 15v11l14 7 14-7V15",
        stroke: "#94A3B8",
        strokeWidth: "1.6",
        strokeLinejoin: "round"
      }
    ),
    /* @__PURE__ */ e.createElement("path", { d: "M20 22v11", stroke: "#94A3B8", strokeWidth: "1.6", strokeLinecap: "round" })
  );
}
function pl({
  icon: t,
  hideIcon: a = !1,
  title: n,
  titleColor: o,
  titleSize: r,
  titleWeight: s,
  description: l,
  actionLabel: d,
  onAction: c,
  bordered: i = !0,
  compact: m = !1
}) {
  const _ = {
    ...o !== void 0 ? { color: o } : {},
    ...r !== void 0 ? { fontSize: r } : {},
    ...s !== void 0 ? { fontWeight: s } : {}
  };
  return /* @__PURE__ */ e.createElement(
    "div",
    {
      className: [ee.wrapper, i && !m ? ee.bordered : "", m ? ee.compact : ""].join(" ")
    },
    !a && /* @__PURE__ */ e.createElement("div", { className: ee.icon }, t != null ? t : /* @__PURE__ */ e.createElement(Ro, null)),
    /* @__PURE__ */ e.createElement("p", { className: ee.title, style: _ }, n),
    l && /* @__PURE__ */ e.createElement("p", { className: ee.description }, l),
    d && c && /* @__PURE__ */ e.createElement("button", { type: "button", className: ee.action, onClick: c }, d)
  );
}
const Po = "_wrapper_oide4_1", Oo = "_toggle_oide4_7", qo = "_toggleOpen_oide4_29", Go = "_panel_oide4_34", Wo = "_text_oide4_41", be = {
  wrapper: Po,
  toggle: Oo,
  toggleOpen: qo,
  panel: Go,
  text: Wo
};
function El({
  label: t,
  summaryText: a,
  open: n,
  onToggle: o
}) {
  return /* @__PURE__ */ e.createElement("div", { className: be.wrapper }, /* @__PURE__ */ e.createElement(
    "button",
    {
      type: "button",
      className: [be.toggle, n ? be.toggleOpen : ""].join(" "),
      onClick: o,
      "aria-expanded": n
    },
    t
  ), n && /* @__PURE__ */ e.createElement("div", { className: be.panel }, /* @__PURE__ */ e.createElement("p", { className: be.text }, a)));
}
const zo = "_wrapper_96dw1_1", Ko = "_labelRow_96dw1_8", Ho = "_label_96dw1_8", Vo = "_value_96dw1_21", Uo = "_track_96dw1_27", Qo = "_xs_96dw1_35", Yo = "_sm_96dw1_39", Jo = "_md_96dw1_43", Zo = "_square_96dw1_47", es = "_fill_96dw1_51", W = {
  wrapper: zo,
  labelRow: Ko,
  label: Ho,
  value: Vo,
  track: Uo,
  xs: Qo,
  sm: Yo,
  md: Jo,
  square: Zo,
  fill: es
};
function fl({
  value: t,
  max: a = 100,
  label: n,
  color: o = "#3B82F6",
  gradient: r,
  size: s = "md",
  rounded: l = !0,
  height: d,
  trackColor: c
}) {
  const i = a > 0 ? a : 100, m = Math.min(100, Math.max(0, t / i * 100)), _ = r ? { width: `${m}%`, background: `linear-gradient(90deg, ${r[0]}, ${r[1]})` } : { width: `${m}%`, backgroundColor: o }, u = {
    ...d !== void 0 ? { height: d } : {},
    ...c !== void 0 ? { background: c } : {}
  };
  return /* @__PURE__ */ e.createElement("div", { className: W.wrapper }, n && /* @__PURE__ */ e.createElement("div", { className: W.labelRow }, /* @__PURE__ */ e.createElement("span", { className: W.label }, n), /* @__PURE__ */ e.createElement("span", { className: W.value }, Math.round(m), "%")), /* @__PURE__ */ e.createElement("div", { className: [W.track, W[s], l ? "" : W.square].join(" "), style: u }, /* @__PURE__ */ e.createElement("div", { className: [W.fill, l ? "" : W.square].join(" "), style: _ })));
}
const ts = "_list_aixh6_1", as = "_vertical_aixh6_8", ns = "_horizontal_aixh6_13", os = "_item_aixh6_18", ss = "_iconWrap_aixh6_41", rs = "_iconSvg_aixh6_51", cs = "_spin_aixh6_56", ls = "_label_aixh6_70", is = "_item_active_aixh6_82", ds = "_item_done_aixh6_87", _s = "_connector_aixh6_91", ms = "_cardList_aixh6_114", us = "_cardItem_aixh6_122", ps = "_card_pending_aixh6_133", Es = "_card_active_aixh6_142", fs = "_card_done_aixh6_152", x = {
  list: ts,
  vertical: as,
  horizontal: ns,
  item: os,
  iconWrap: ss,
  iconSvg: rs,
  spin: cs,
  "ax-step-spin": "_ax-step-spin_aixh6_1",
  label: ls,
  item_active: is,
  item_done: ds,
  connector: _s,
  cardList: ms,
  cardItem: us,
  card_pending: ps,
  card_active: Es,
  card_done: fs
};
function bs({ status: t }) {
  return t === "done" ? /* @__PURE__ */ e.createElement(
    "svg",
    {
      className: x.iconSvg,
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ e.createElement("circle", { cx: "10", cy: "10", r: "9", fill: "#F0FDF4", stroke: "#166534", strokeWidth: "1.5" }),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M6 10.2l2.4 2.4L14 7",
        stroke: "#166534",
        strokeWidth: "1.7",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    )
  ) : t === "active" ? /* @__PURE__ */ e.createElement(
    "svg",
    {
      className: [x.iconSvg, x.spin].join(" "),
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ e.createElement(
      "circle",
      {
        cx: "10",
        cy: "10",
        r: "8",
        stroke: "#E2E8F0",
        strokeWidth: "2.5"
      }
    ),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M18 10a8 8 0 00-8-8",
        stroke: "#3B82F6",
        strokeWidth: "2.5",
        strokeLinecap: "round"
      }
    )
  ) : /* @__PURE__ */ e.createElement(
    "svg",
    {
      className: x.iconSvg,
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ e.createElement("circle", { cx: "10", cy: "10", r: "8", stroke: "#94A3B8", strokeWidth: "1.5" })
  );
}
function bl({
  steps: t,
  orientation: a = "vertical",
  variant: n = "timeline"
}) {
  const o = n === "card";
  return /* @__PURE__ */ e.createElement("ul", { className: [x.list, x[a], o ? x.cardList : ""].join(" ") }, t.map((r, s) => /* @__PURE__ */ e.createElement(
    "li",
    {
      key: `${r.label}-${s}`,
      className: [
        x.item,
        o ? x.cardItem : "",
        x[`item_${r.status}`],
        o ? x[`card_${r.status}`] : ""
      ].join(" ")
    },
    /* @__PURE__ */ e.createElement("span", { className: x.iconWrap }, /* @__PURE__ */ e.createElement(bs, { status: r.status })),
    /* @__PURE__ */ e.createElement("span", { className: x.label }, r.label),
    !o && s < t.length - 1 && /* @__PURE__ */ e.createElement("span", { className: x.connector })
  )));
}
const ys = "_wrapper_1ohmw_1", gs = "_icon_1ohmw_7", hs = "_dots_1ohmw_14", vs = "_dot_1ohmw_14", ks = "_sm_1ohmw_27", Ns = "_md_1ohmw_32", te = {
  wrapper: ys,
  icon: gs,
  dots: hs,
  dot: vs,
  "ax-typing-bounce": "_ax-typing-bounce_1ohmw_1",
  sm: ks,
  md: Ns
};
function yl({ withIcon: t, size: a = "md" }) {
  return /* @__PURE__ */ e.createElement("div", { className: te.wrapper }, t && /* @__PURE__ */ e.createElement("span", { className: te.icon }, t), /* @__PURE__ */ e.createElement("span", { className: [te.dots, te[a]].join(" ") }, /* @__PURE__ */ e.createElement("span", { className: te.dot }), /* @__PURE__ */ e.createElement("span", { className: te.dot }), /* @__PURE__ */ e.createElement("span", { className: te.dot })));
}
const As = "_container_85404_1", ws = "_table_85404_9", $s = "_row_85404_31", xs = "_striped_85404_35", Xs = "_clickable_85404_43", Cs = "_alignLeft_85404_47", Ss = "_alignCenter_85404_51", Bs = "_alignRight_85404_55", Fs = "_emptyCell_85404_59", z = {
  container: As,
  table: ws,
  row: $s,
  striped: xs,
  clickable: Xs,
  alignLeft: Cs,
  alignCenter: Ss,
  alignRight: Bs,
  emptyCell: Fs
};
function gl({
  columns: t,
  rows: a,
  striped: n = !0,
  onRowClick: o,
  emptyMessage: r = "데이터가 없습니다"
}) {
  const s = (l) => l === "center" ? z.alignCenter : l === "right" ? z.alignRight : z.alignLeft;
  return /* @__PURE__ */ e.createElement("div", { className: z.container }, /* @__PURE__ */ e.createElement("table", { className: z.table }, /* @__PURE__ */ e.createElement("thead", null, /* @__PURE__ */ e.createElement("tr", null, t.map((l) => /* @__PURE__ */ e.createElement(
    "th",
    {
      key: l.key,
      className: s(l.align),
      style: l.width ? { width: l.width } : void 0
    },
    l.label
  )))), /* @__PURE__ */ e.createElement("tbody", null, a.length === 0 ? /* @__PURE__ */ e.createElement("tr", null, /* @__PURE__ */ e.createElement("td", { className: z.emptyCell, colSpan: t.length }, r)) : a.map((l, d) => {
    const c = [
      z.row,
      n && d % 2 === 1 ? z.striped : "",
      o ? z.clickable : ""
    ].filter(Boolean).join(" ");
    return /* @__PURE__ */ e.createElement(
      "tr",
      {
        key: d,
        className: c,
        onClick: o ? () => o(l, d) : void 0
      },
      t.map((i) => /* @__PURE__ */ e.createElement("td", { key: i.key, className: s(i.align) }, l[i.key]))
    );
  }))));
}
const Is = "_grid_plbcd_1", js = "_cell_plbcd_6", Ls = "_primaryCell_plbcd_16", Ds = "_label_plbcd_21", Ms = "_value_plbcd_26", Ts = "_note_plbcd_32", se = {
  grid: Is,
  cell: js,
  primaryCell: Ls,
  label: Ds,
  value: Ms,
  note: Ts
};
function hl({
  items: t,
  columns: a = 4,
  primaryFirst: n = !1,
  cellBackground: o,
  cellBorderColor: r,
  labelColor: s,
  valueColor: l,
  primaryBackground: d,
  primaryLabelColor: c,
  primaryValueColor: i,
  primaryNoteColor: m
}) {
  return /* @__PURE__ */ e.createElement(
    "div",
    {
      className: se.grid,
      style: { gridTemplateColumns: `repeat(${a}, 1fr)` }
    },
    t.map((_, u) => {
      const f = n && u === 0, y = [se.cell, f ? se.primaryCell : ""].filter(Boolean).join(" "), E = {};
      o !== void 0 && (E.background = o), r !== void 0 && (E.borderColor = r), f && d !== void 0 && (E.background = d, E.borderColor = "transparent");
      const h = {};
      s !== void 0 && (h.color = s), f && c !== void 0 && (h.color = c);
      const w = {};
      l !== void 0 && (w.color = l), f && i !== void 0 && (w.color = i);
      const X = {};
      return f && m !== void 0 && (X.color = m), /* @__PURE__ */ e.createElement("div", { key: `${_.label}-${u}`, className: y, style: E }, /* @__PURE__ */ e.createElement("span", { className: se.label, style: h }, _.label), /* @__PURE__ */ e.createElement("span", { className: se.value, style: w }, _.value), _.note && /* @__PURE__ */ e.createElement("span", { className: se.note, style: X }, _.note));
    })
  );
}
const Rs = "_button_16ajt_1", Ps = "_disabledSolid_16ajt_19", Os = "_icon_16ajt_26", qs = "_label_16ajt_32", Gs = "_fullWidth_16ajt_37", Ws = "_sm_16ajt_41", zs = "_md_16ajt_47", Ks = "_lg_16ajt_53", Hs = "_primary_16ajt_59", Vs = "_secondary_16ajt_70", Us = "_outline_16ajt_81", Qs = "_ghost_16ajt_93", Ys = "_active_16ajt_104", Js = "_colorOverride_16ajt_116", Zs = "_gradient_16ajt_126", er = "_dashed_16ajt_135", tr = "_pill_16ajt_139", L = {
  button: Rs,
  disabledSolid: Ps,
  icon: Os,
  label: qs,
  fullWidth: Gs,
  sm: Ws,
  md: zs,
  lg: Ks,
  primary: Hs,
  secondary: Vs,
  outline: Us,
  ghost: Qs,
  active: Ys,
  colorOverride: Js,
  gradient: Zs,
  dashed: er,
  pill: tr
};
function vl({
  variant: t = "primary",
  size: a = "md",
  icon: n,
  iconPosition: o = "leading",
  disabled: r = !1,
  disabledVariant: s = "dim",
  onClick: l,
  children: d,
  fullWidth: c = !1,
  type: i = "button",
  active: m = !1,
  color: _,
  background: u,
  borderColor: f,
  hoverColor: y,
  hoverBackground: E,
  gradient: h,
  borderStyle: w = "solid",
  shape: X = "rounded"
}) {
  const T = _ !== void 0 || f !== void 0 || y !== void 0 || E !== void 0, O = [
    L.button,
    L[t],
    L[a],
    c ? L.fullWidth : "",
    r && s === "solid" ? L.disabledSolid : "",
    m ? L.active : "",
    T ? L.colorOverride : "",
    h || u ? L.gradient : "",
    w === "dashed" ? L.dashed : "",
    X === "pill" ? L.pill : ""
  ].filter(Boolean).join(" "), q = {
    ..._ !== void 0 ? { "--ax-btn-color": _ } : {},
    ...f !== void 0 ? { "--ax-btn-border": f } : {},
    ...y !== void 0 ? { "--ax-btn-hover-color": y } : {},
    ...E !== void 0 ? { "--ax-btn-hover-bg": E } : {},
    ...h ? { background: `linear-gradient(135deg, ${h[0]}, ${h[1]})` } : {},
    ...u !== void 0 ? { background: u } : {}
  }, V = n && /* @__PURE__ */ e.createElement("span", { className: L.icon }, n);
  return /* @__PURE__ */ e.createElement(
    "button",
    {
      type: i,
      className: O,
      style: q,
      disabled: r,
      onClick: l
    },
    o === "leading" && V,
    /* @__PURE__ */ e.createElement("span", { className: L.label }, d),
    o === "trailing" && V
  );
}
const ar = "_iconButton_1oiog_1", nr = "_sm_1oiog_18", or = "_md_1oiog_23", sr = "_lg_1oiog_28", rr = "_plain_1oiog_33", cr = "_outline_1oiog_42", lr = "_circle_1oiog_53", ir = "_bordered_1oiog_62", dr = "_tint_1oiog_73", _r = "_active_1oiog_81", mr = "_hoverBgOverride_1oiog_92", ur = "_gradient_1oiog_96", Y = {
  iconButton: ar,
  sm: nr,
  md: or,
  lg: sr,
  plain: rr,
  outline: cr,
  circle: lr,
  bordered: ir,
  tint: dr,
  active: _r,
  hoverBgOverride: mr,
  gradient: ur
};
function kl({
  icon: t,
  title: a,
  active: n = !1,
  size: o = "md",
  variant: r = "plain",
  onClick: s,
  onMouseDown: l,
  disabled: d = !1,
  color: c,
  hoverColor: i,
  bordered: m = !1,
  borderColor: _ = "#e2e8f0",
  borderHoverColor: u = "#3b82f6",
  tint: f = !1,
  tintColor: y = "#eef4ff",
  tintHoverColor: E = "#dbeafe",
  hoverBackground: h,
  gradient: w
}) {
  const X = typeof o == "number", T = [
    Y.iconButton,
    X ? "" : Y[o],
    Y[r],
    n ? Y.active : "",
    m ? Y.bordered : "",
    f ? Y.tint : "",
    h !== void 0 ? Y.hoverBgOverride : "",
    w ? Y.gradient : ""
  ].filter(Boolean).join(" "), O = {
    ...X ? { width: o, height: o } : {},
    ...c !== void 0 ? { "--ax-icon-color": c } : {},
    ...i !== void 0 ? { "--ax-icon-hover": i } : {},
    ...m ? { "--ax-icon-border": _, "--ax-icon-border-hover": u } : {},
    ...f ? { "--ax-icon-tint": y, "--ax-icon-tint-hover": E } : {},
    ...h !== void 0 ? { "--ax-icon-hover-bg": h } : {},
    ...w ? { background: `linear-gradient(135deg, ${w[0]}, ${w[1]})` } : {}
  };
  return /* @__PURE__ */ e.createElement(
    "button",
    {
      type: "button",
      className: T,
      style: O,
      onClick: s,
      onMouseDown: l,
      disabled: d,
      title: a,
      "aria-label": a
    },
    t
  );
}
const pr = "_control_8lntr_1", Er = "_option_8lntr_13", fr = "_active_8lntr_31", br = "_sm_8lntr_40", yr = "_md_8lntr_46", gr = "_dot_8lntr_52", hr = "_count_8lntr_59", vr = "_outline_8lntr_73", kr = "_outlineOption_8lntr_78", K = {
  control: pr,
  option: Er,
  active: fr,
  sm: br,
  md: yr,
  dot: gr,
  count: hr,
  outline: vr,
  outlineOption: kr
};
function Nl({
  options: t,
  value: a,
  onChange: n,
  size: o = "md",
  variant: r = "filled",
  activeBackground: s,
  activeColor: l,
  activeBorderColor: d
}) {
  return /* @__PURE__ */ e.createElement(
    "div",
    {
      className: [K.control, K[o], r === "outline" ? K.outline : ""].filter(Boolean).join(" "),
      role: "tablist"
    },
    t.map((c) => {
      const i = c.value === a, m = i ? {
        ...s !== void 0 ? { background: s } : {},
        ...l !== void 0 ? { color: l } : {},
        ...d !== void 0 ? { borderColor: d } : {}
      } : void 0;
      return /* @__PURE__ */ e.createElement(
        "button",
        {
          key: c.value,
          type: "button",
          role: "tab",
          "aria-selected": i,
          className: [K.option, i ? K.active : "", r === "outline" ? K.outlineOption : ""].filter(Boolean).join(" "),
          style: m,
          onClick: () => n(c.value)
        },
        c.dot && /* @__PURE__ */ e.createElement("span", { className: K.dot, style: { backgroundColor: c.dot } }),
        /* @__PURE__ */ e.createElement("span", { className: K.label }, c.label),
        typeof c.count == "number" && /* @__PURE__ */ e.createElement("span", { className: K.count }, c.count)
      );
    })
  );
}
const Nr = "_chip_8jgxm_1", Ar = "_clickable_8jgxm_14", wr = "_suggested_8jgxm_23", $r = "_readonly_8jgxm_33", xr = "_plusIcon_8jgxm_39", Xr = "_label_8jgxm_45", Cr = "_removeButton_8jgxm_50", re = {
  chip: Nr,
  clickable: Ar,
  default: "_default_8jgxm_18",
  suggested: wr,
  readonly: $r,
  plusIcon: xr,
  label: Xr,
  removeButton: Cr
};
function Al({
  label: t,
  variant: a = "default",
  onRemove: n,
  onClick: o,
  background: r,
  textColor: s,
  borderColor: l
}) {
  const d = [re.chip, re[a], o ? re.clickable : ""].filter(Boolean).join(" "), i = r !== void 0 || s !== void 0 || l !== void 0 ? {
    ...r !== void 0 ? { background: r } : {},
    ...s !== void 0 ? { color: s } : {},
    ...l !== void 0 ? { borderColor: l } : {}
  } : {}, m = a !== "readonly" && !!n, _ = /* @__PURE__ */ e.createElement(e.Fragment, null, a === "suggested" && /* @__PURE__ */ e.createElement("span", { className: re.plusIcon, "aria-hidden": "true" }, "+"), /* @__PURE__ */ e.createElement("span", { className: re.label }, t), m && /* @__PURE__ */ e.createElement(
    "button",
    {
      type: "button",
      className: re.removeButton,
      "aria-label": `remove ${t}`,
      onClick: (u) => {
        u.stopPropagation(), n == null || n();
      }
    },
    /* @__PURE__ */ e.createElement("svg", { width: "10", height: "10", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2.5", strokeLinecap: "round", strokeLinejoin: "round" }, /* @__PURE__ */ e.createElement("path", { d: "M18 6L6 18" }), /* @__PURE__ */ e.createElement("path", { d: "M6 6l12 12" }))
  ));
  return o ? /* @__PURE__ */ e.createElement(
    "div",
    {
      role: "button",
      tabIndex: 0,
      className: d,
      style: i,
      onClick: o,
      onKeyDown: (u) => {
        (u.key === "Enter" || u.key === " ") && (u.preventDefault(), o());
      }
    },
    _
  ) : /* @__PURE__ */ e.createElement("span", { className: d, style: i }, _);
}
const Sr = "_wrapper_15dm4_1", Br = "_disabled_15dm4_8", Fr = "_track_15dm4_13", Ir = "_checked_15dm4_30", jr = "_thumb_15dm4_34", Lr = "_label_15dm4_50", ce = {
  wrapper: Sr,
  disabled: Br,
  track: Fr,
  checked: Ir,
  thumb: jr,
  label: Lr
};
function wl({
  checked: t,
  onChange: a,
  labelOn: n,
  labelOff: o,
  disabled: r = !1,
  color: s
}) {
  const l = t ? n : o;
  return /* @__PURE__ */ e.createElement("label", { className: [ce.wrapper, r ? ce.disabled : ""].filter(Boolean).join(" ") }, /* @__PURE__ */ e.createElement(
    "button",
    {
      type: "button",
      role: "switch",
      "aria-checked": t,
      disabled: r,
      className: [ce.track, t ? ce.checked : ""].filter(Boolean).join(" "),
      style: t && s !== void 0 ? { background: s } : void 0,
      onClick: () => !r && a(!t)
    },
    /* @__PURE__ */ e.createElement("span", { className: ce.thumb })
  ), l && /* @__PURE__ */ e.createElement("span", { className: ce.label }, l));
}
const Dr = "_card_1uh3t_1", Mr = "_active_1uh3t_24", Tr = "_iconChip_1uh3t_29", Rr = "_body_1uh3t_41", Pr = "_label_1uh3t_48", Or = "_description_1uh3t_54", le = {
  card: Dr,
  active: Mr,
  iconChip: Tr,
  body: Rr,
  label: Pr,
  description: Or
};
function $l(t) {
  const { icon: a, label: n, description: o, active: r = !1, onClick: s } = t;
  return /* @__PURE__ */ e.createElement(
    "button",
    {
      type: "button",
      className: `${le.card} ${r ? le.active : ""}`,
      onClick: s,
      "aria-pressed": r
    },
    /* @__PURE__ */ e.createElement("span", { className: le.iconChip }, a),
    /* @__PURE__ */ e.createElement("span", { className: le.body }, /* @__PURE__ */ e.createElement("span", { className: le.label }, n), o && /* @__PURE__ */ e.createElement("span", { className: le.description }, o))
  );
}
const qr = "_breadcrumb_zkol9_1", Gr = "_list_zkol9_6", Wr = "_item_zkol9_16", zr = "_link_zkol9_22", Kr = "_plain_zkol9_43", Hr = "_current_zkol9_48", Vr = "_separator_zkol9_54", ae = {
  breadcrumb: qr,
  list: Gr,
  item: Wr,
  link: zr,
  plain: Kr,
  current: Hr,
  separator: Vr
};
function xl(t) {
  const { items: a, separator: n = "/", textColor: o, hoverColor: r, currentColor: s } = t, l = {
    ...o !== void 0 ? { "--ax-bc-text": o } : {},
    ...r !== void 0 ? { "--ax-bc-hover": r } : {},
    ...s !== void 0 ? { "--ax-bc-current": s } : {}
  };
  return /* @__PURE__ */ e.createElement("nav", { className: ae.breadcrumb, "aria-label": "breadcrumb", style: l }, /* @__PURE__ */ e.createElement("ol", { className: ae.list }, a.map((d, c) => {
    const i = c === a.length - 1;
    return /* @__PURE__ */ e.createElement("li", { key: c, className: ae.item }, i ? /* @__PURE__ */ e.createElement("span", { className: ae.current, "aria-current": "page" }, d.label) : d.onClick ? /* @__PURE__ */ e.createElement(
      "button",
      {
        type: "button",
        className: ae.link,
        onClick: d.onClick
      },
      d.label
    ) : /* @__PURE__ */ e.createElement("span", { className: ae.plain }, d.label), !i && /* @__PURE__ */ e.createElement("span", { className: ae.separator, "aria-hidden": "true" }, n));
  })));
}
const Ur = "_treeItem_1ouqz_1", Qr = "_active_1ouqz_18", Yr = "_chevron_1ouqz_28", Jr = "_chevronExpanded_1ouqz_48", Zr = "_chevronSpacer_1ouqz_52", ec = "_icon_1ouqz_57", tc = "_label_1ouqz_69", ac = "_count_1ouqz_76", nc = "_dark_1ouqz_86", H = {
  treeItem: Ur,
  active: Qr,
  chevron: Yr,
  chevronExpanded: Jr,
  chevronSpacer: Zr,
  icon: ec,
  label: tc,
  count: ac,
  dark: nc
};
function Xl(t) {
  const {
    icon: a,
    label: n,
    count: o,
    indent: r = 0,
    active: s = !1,
    expandable: l = !1,
    expanded: d = !1,
    theme: c = "light",
    onToggleExpand: i,
    onClick: m
  } = t, _ = (f) => {
    f.stopPropagation(), i == null || i();
  }, u = c === "dark" ? H.dark : "";
  return /* @__PURE__ */ e.createElement(
    "div",
    {
      className: `${H.treeItem} ${u} ${s ? H.active : ""}`,
      style: { paddingLeft: 12 + r * 16 },
      onClick: m,
      role: "treeitem",
      "aria-selected": s,
      "aria-expanded": l ? d : void 0
    },
    l ? /* @__PURE__ */ e.createElement(
      "button",
      {
        type: "button",
        className: `${H.chevron} ${d ? H.chevronExpanded : ""}`,
        onClick: _,
        "aria-label": d ? "Collapse" : "Expand"
      },
      /* @__PURE__ */ e.createElement("svg", { width: "10", height: "10", viewBox: "0 0 10 10", fill: "none" }, /* @__PURE__ */ e.createElement(
        "path",
        {
          d: "M3 1.5L7 5L3 8.5",
          stroke: "currentColor",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      ))
    ) : /* @__PURE__ */ e.createElement("span", { className: H.chevronSpacer }),
    a && /* @__PURE__ */ e.createElement("span", { className: H.icon }, a),
    /* @__PURE__ */ e.createElement("span", { className: H.label }, n),
    typeof o == "number" && /* @__PURE__ */ e.createElement("span", { className: H.count }, o)
  );
}
const oc = 'a[href],button:not(:disabled),input:not(:disabled):not([type=hidden]),select:not(:disabled),textarea:not(:disabled),[tabindex]:not([tabindex="-1"])';
function Qe(t) {
  return Array.from(t.querySelectorAll(oc)).filter((a) => a.getClientRects().length > 0 && getComputedStyle(a).visibility !== "hidden");
}
let Ye = 0, Je = "";
function it(t) {
  const a = J(null), n = J(t);
  n.current = t;
  const o = J(void 0);
  return o.current === void 0 && (o.current = typeof document == "undefined" ? null : document.activeElement), Z(() => {
    var d;
    const s = a.current, l = (d = o.current) != null ? d : null;
    return s && !s.contains(document.activeElement) && (Qe(s)[0] || s).focus(), Ye++ === 0 && (Je = document.body.style.overflow, document.body.style.overflow = "hidden"), () => {
      --Ye === 0 && (document.body.style.overflow = Je), l && l.isConnected && typeof l.focus == "function" && l.focus();
    };
  }, []), { dialogRef: a, onKeyDown: (s) => {
    const l = a.current;
    if (!l) return;
    if (s.key === "Escape") {
      s.stopPropagation(), n.current();
      return;
    }
    if (s.key !== "Tab" || !l.contains(s.target)) return;
    const d = Qe(l);
    if (d.length === 0) {
      s.preventDefault(), l.focus();
      return;
    }
    const c = d[0], i = d[d.length - 1], m = document.activeElement;
    s.shiftKey && (m === c || m === l) ? (s.preventDefault(), i.focus()) : !s.shiftKey && m === i && (s.preventDefault(), c.focus());
  } };
}
const sc = "_backdrop_gstyy_1", rc = "_panel_gstyy_9", cc = "_right_gstyy_21", lc = "_left_gstyy_27", ic = "_header_gstyy_51", dc = "_icon_gstyy_59", _c = "_titleGroup_gstyy_66", mc = "_kicker_gstyy_71", uc = "_title_gstyy_66", pc = "_subtitle_gstyy_87", Ec = "_closeButton_gstyy_93", fc = "_body_gstyy_115", bc = "_footer_gstyy_123", I = {
  backdrop: sc,
  panel: rc,
  right: cc,
  left: lc,
  header: ic,
  icon: dc,
  titleGroup: _c,
  kicker: mc,
  title: uc,
  subtitle: pc,
  closeButton: Ec,
  body: fc,
  footer: bc
};
function Cl(t) {
  return t.open ? /* @__PURE__ */ e.createElement(yc, { ...t }) : null;
}
function yc({
  onClose: t,
  icon: a,
  kicker: n,
  title: o,
  titleSize: r,
  titleWeight: s,
  subtitle: l,
  footer: d,
  children: c,
  side: i = "right",
  headerBackground: m,
  topOffset: _
}) {
  const { dialogRef: u, onKeyDown: f } = it(t), y = Ze("ax-drawer-t"), E = [I.panel, i === "left" ? I.left : I.right].filter(Boolean).join(" "), h = {
    ...r !== void 0 ? { fontSize: r } : {},
    ...s !== void 0 ? { fontWeight: s } : {}
  }, w = _ !== void 0 ? { top: _, height: `calc(100vh - ${_}px)` } : void 0;
  return /* @__PURE__ */ e.createElement("div", { className: I.backdrop, onClick: t }, /* @__PURE__ */ e.createElement(
    "div",
    {
      ref: u,
      tabIndex: -1,
      role: "dialog",
      "aria-modal": "true",
      "aria-labelledby": y,
      className: E,
      style: w,
      onClick: (X) => X.stopPropagation(),
      onKeyDown: f
    },
    /* @__PURE__ */ e.createElement("div", { className: I.header, style: m !== void 0 ? { background: m } : void 0 }, a && /* @__PURE__ */ e.createElement("span", { className: I.icon }, a), /* @__PURE__ */ e.createElement("div", { className: I.titleGroup }, n && /* @__PURE__ */ e.createElement("p", { className: I.kicker }, n), /* @__PURE__ */ e.createElement("h2", { className: I.title, id: y, style: h }, o), l && /* @__PURE__ */ e.createElement("p", { className: I.subtitle }, l)), /* @__PURE__ */ e.createElement(
      "button",
      {
        type: "button",
        className: I.closeButton,
        onClick: t,
        "aria-label": "닫기"
      },
      "×"
    )),
    /* @__PURE__ */ e.createElement("div", { className: I.body }, c),
    d && /* @__PURE__ */ e.createElement("div", { className: I.footer }, d)
  ));
}
const gc = "_backdrop_6kso7_1", hc = "_menu_6kso7_8", vc = "_alignRight_6kso7_24", kc = "_alignLeft_6kso7_28", Nc = "_item_6kso7_32", Ac = "_itemIcon_6kso7_50", wc = "_itemText_6kso7_59", $c = "_itemLabel_6kso7_66", xc = "_itemDescription_6kso7_72", Xc = "_danger_6kso7_77", R = {
  backdrop: gc,
  menu: hc,
  alignRight: vc,
  alignLeft: kc,
  item: Nc,
  itemIcon: Ac,
  itemText: wc,
  itemLabel: $c,
  itemDescription: xc,
  danger: Xc
};
function Sl(t) {
  return t.open ? /* @__PURE__ */ e.createElement(Cc, { ...t }) : null;
}
function Cc({
  onClose: t,
  items: a,
  anchor: n = "right"
}) {
  const o = J(null), r = J(void 0);
  r.current === void 0 && (r.current = typeof document == "undefined" ? null : document.activeElement), Z(() => {
    var i, m, _;
    const c = (i = r.current) != null ? i : null;
    return (_ = (m = o.current) == null ? void 0 : m.querySelector("button")) == null || _.focus(), () => {
      c && c.isConnected && typeof c.focus == "function" && c.focus();
    };
  }, []);
  const s = [R.menu, n === "left" ? R.alignLeft : R.alignRight].filter(Boolean).join(" "), l = (c) => {
    c.onClick(), t();
  }, d = (c) => {
    var u, f;
    const i = Array.from((f = (u = o.current) == null ? void 0 : u.querySelectorAll("button")) != null ? f : []), m = i.indexOf(document.activeElement), _ = (y) => {
      var E;
      c.preventDefault(), (E = i[(y + i.length) % i.length]) == null || E.focus();
    };
    c.key === "ArrowDown" ? _(m + 1) : c.key === "ArrowUp" ? _(m <= 0 ? i.length - 1 : m - 1) : c.key === "Home" ? _(0) : c.key === "End" ? _(i.length - 1) : (c.key === "Escape" || c.key === "Tab") && (c.key === "Escape" && c.preventDefault(), t());
  };
  return /* @__PURE__ */ e.createElement(dt, null, /* @__PURE__ */ e.createElement("div", { className: R.backdrop, onClick: t }), /* @__PURE__ */ e.createElement("div", { ref: o, role: "menu", className: s, onClick: (c) => c.stopPropagation(), onKeyDown: d }, a.map((c, i) => {
    const m = [R.item, c.danger ? R.danger : ""].filter(Boolean).join(" ");
    return /* @__PURE__ */ e.createElement(
      "button",
      {
        key: i,
        type: "button",
        role: "menuitem",
        className: m,
        onClick: () => l(c)
      },
      c.icon && /* @__PURE__ */ e.createElement("span", { className: R.itemIcon }, c.icon),
      /* @__PURE__ */ e.createElement("span", { className: R.itemText }, /* @__PURE__ */ e.createElement("span", { className: R.itemLabel }, c.label), c.description && /* @__PURE__ */ e.createElement("span", { className: R.itemDescription }, c.description))
    );
  })));
}
const Sc = "_backdrop_3pc9i_1", Bc = "_card_3pc9i_12", Fc = "_header_3pc9i_23", Ic = "_icon_3pc9i_31", jc = "_titleGroup_3pc9i_38", Lc = "_title_3pc9i_38", Dc = "_subtitle_3pc9i_50", Mc = "_closeButton_3pc9i_56", Tc = "_body_3pc9i_78", Rc = "_footer_3pc9i_85", P = {
  backdrop: Sc,
  card: Bc,
  header: Fc,
  icon: Ic,
  titleGroup: jc,
  title: Lc,
  subtitle: Dc,
  closeButton: Mc,
  body: Tc,
  footer: Rc
};
function Bl(t) {
  return t.open ? /* @__PURE__ */ e.createElement(Pc, { ...t }) : null;
}
function Pc({
  onClose: t,
  icon: a,
  title: n,
  subtitle: o,
  footer: r,
  width: s = 480,
  children: l
}) {
  const { dialogRef: d, onKeyDown: c } = it(t), i = Ze("ax-modal-t"), m = typeof s == "number" ? `${s}px` : s;
  return /* @__PURE__ */ e.createElement("div", { className: P.backdrop, onClick: t }, /* @__PURE__ */ e.createElement(
    "div",
    {
      ref: d,
      tabIndex: -1,
      role: "dialog",
      "aria-modal": "true",
      "aria-labelledby": i,
      className: P.card,
      style: { width: m },
      onClick: (_) => _.stopPropagation(),
      onKeyDown: c
    },
    /* @__PURE__ */ e.createElement("div", { className: P.header }, a && /* @__PURE__ */ e.createElement("span", { className: P.icon }, a), /* @__PURE__ */ e.createElement("div", { className: P.titleGroup }, /* @__PURE__ */ e.createElement("h2", { className: P.title, id: i }, n), o && /* @__PURE__ */ e.createElement("p", { className: P.subtitle }, o)), /* @__PURE__ */ e.createElement(
      "button",
      {
        type: "button",
        className: P.closeButton,
        onClick: t,
        "aria-label": "닫기"
      },
      "×"
    )),
    /* @__PURE__ */ e.createElement("div", { className: P.body }, l),
    r && /* @__PURE__ */ e.createElement("div", { className: P.footer }, r)
  ));
}
export {
  xe as ACTIVE_AFFILIATION_KEY_PREFIX,
  Nt as ACTIVE_COM_HEADER,
  At as ACTIVE_DEPT_HEADER,
  $l as AXActionCard,
  nl as AXAiIconBadge,
  ul as AXAiSuggestionBanner,
  lt as AXAvatar,
  ol as AXAvatarStack,
  sl as AXBadge,
  xl as AXBreadcrumb,
  vl as AXButton,
  el as AXCardPanel,
  rl as AXCommentRow,
  Jc as AXCommentThread,
  gl as AXDataTable,
  tl as AXDivider,
  Cl as AXDrawer,
  Sl as AXDropdownMenu,
  ym as AXERP_EMPTY_SET_TEXT,
  jl as AXE_MONEY_REJECT_TEXT,
  pl as AXEmptyState,
  Ll as AXErpAccordion,
  Dl as AXErpActionMenu,
  Ml as AXErpAiAnswerPanel,
  Tl as AXErpBanner,
  Rl as AXErpBarChart,
  Pl as AXErpButton,
  Ol as AXErpCalculatorModal,
  ql as AXErpCalculatorProvider,
  Gl as AXErpCalendar,
  Wl as AXErpCard,
  zl as AXErpCheckGroup,
  Kl as AXErpCheckList,
  Hl as AXErpCheckbox,
  Vl as AXErpCodeBadge,
  Ul as AXErpCodePicker,
  Ql as AXErpContextHelp,
  Yl as AXErpContextMenu,
  Jl as AXErpCriticalAlert,
  Zl as AXErpCsvButton,
  ei as AXErpCsvPick,
  ti as AXErpDataTable,
  ai as AXErpDatePicker,
  ni as AXErpDateRange,
  oi as AXErpDonutChart,
  si as AXErpDropArea,
  ri as AXErpEmptySet,
  ci as AXErpError,
  li as AXErpField,
  ii as AXErpFileButton,
  di as AXErpFileDrop,
  _i as AXErpFilterBand,
  mi as AXErpFormModal,
  ui as AXErpFormRow,
  pi as AXErpFormSection,
  Ei as AXErpGantt,
  fi as AXErpGisuField,
  bi as AXErpGlyph,
  yi as AXErpGrid,
  gi as AXErpGridStatus,
  hi as AXErpHint,
  vi as AXErpIcon,
  ki as AXErpIconButton,
  Ni as AXErpImageThumbs,
  Ai as AXErpKanban,
  wi as AXErpKpiTile,
  $i as AXErpKpiTileGroup,
  xi as AXErpLinkButton,
  Xi as AXErpLoadMore,
  Ci as AXErpMainScreen,
  Si as AXErpMenuAreaHead,
  Bi as AXErpMenuGroup,
  Fi as AXErpMiniCalendar,
  Ii as AXErpModal,
  ji as AXErpMoneyInput,
  Li as AXErpMsg,
  Di as AXErpMultiSelect,
  Mi as AXErpNote,
  Ti as AXErpOverviewGrid,
  Ri as AXErpPage,
  Pi as AXErpPageBody,
  Oi as AXErpPageFrame,
  qi as AXErpPagination,
  Gi as AXErpPill,
  Wi as AXErpPopover,
  zi as AXErpProgressBar,
  Ki as AXErpProposalBanner,
  Hi as AXErpProposalCards,
  Vi as AXErpProposalList,
  Ui as AXErpProposalModal,
  Qi as AXErpQtyInput,
  Yi as AXErpQuickMenu,
  Ji as AXErpRadioGroup,
  Zi as AXErpReadonly,
  ed as AXErpReadout,
  td as AXErpSaveBar,
  ad as AXErpSearchBar,
  nd as AXErpSelect,
  od as AXErpShortcutHelp,
  sd as AXErpSideBar,
  rd as AXErpSidePanel,
  cd as AXErpSidePanelGroup,
  ld as AXErpSkipLink,
  id as AXErpSortAnnounce,
  dd as AXErpSortButton,
  _d as AXErpSortTh,
  md as AXErpSpinner,
  ud as AXErpStartGuide,
  pd as AXErpStatCard,
  Ed as AXErpStateBadge,
  fd as AXErpStepIndicator,
  bd as AXErpSummaryCard,
  yd as AXErpSummaryList,
  gd as AXErpSwitch,
  hd as AXErpTabs,
  vd as AXErpTag,
  kd as AXErpTagList,
  Nd as AXErpTextInput,
  Ad as AXErpTitleBar,
  wd as AXErpToastProvider,
  $d as AXErpToggle,
  xd as AXErpTooltip,
  Xd as AXErpTreeCell,
  Cd as AXErpVerify,
  Sd as AXErpVirtualBody,
  Bd as AXErpVisuallyHidden,
  Fd as AXErpWeekStepper,
  Id as AXErpWeekStrip,
  El as AXExpandableSummary,
  cl as AXFileChip,
  gn as AXFileTypeIcon,
  kl as AXIconButton,
  hl as AXKeyValueGrid,
  ll as AXKeyValueRow,
  il as AXListRow,
  Bl as AXModal,
  al as AXPanelHeader,
  dl as AXPersonRow,
  fl as AXProgressBar,
  _l as AXRankingRow,
  jd as AXSearchInput,
  Nl as AXSegmentedControl,
  ml as AXStatusBadge,
  bl as AXStepProgress,
  Al as AXTagChip,
  wl as AXToggleSwitch,
  Xl as AXTreeItem,
  yl as AXTypingDots,
  Ld as AX_ERP_CALENDAR_KO,
  Dd as AX_ERP_DIRTY_MESSAGE,
  Md as AX_ERP_SHORTCUTS,
  Qc as CurrencyUnit,
  Td as ERP_AREA_BASE,
  Rd as ERP_AREA_MIN,
  Pd as ERP_AREA_MIN_PINNED,
  Od as ERP_HOST_SIDE,
  qd as ERP_HOST_TOP,
  Gd as ERP_PAGE_MIN_WIDTH,
  Wd as ERP_PAGE_MIN_WIDTH_MAX,
  zd as ERP_VIEWPORT_BASE,
  Kd as ERP_VIEWPORT_MIN,
  De as GW_ORIGIN,
  Hd as JAPANESE_ERAS,
  Vd as OBTPortal,
  Ud as OBTResizeContainer,
  Qd as OBTResizeSensor,
  ne as REFRESH_KEY,
  Be as SESSION_EXPIRED_EVENT,
  Le as TOKEN_KEY,
  wt as activeAffiliationHeaders,
  gm as amDigits,
  hm as amNumber,
  ie as authorizedFetch,
  Yd as axErpAddDays,
  Jd as axErpAriaSort,
  Zd as axErpAutoLineAm,
  e_ as axErpCalendarLocale,
  t_ as axErpChangedKeys,
  a_ as axErpCodeDisplay,
  n_ as axErpCodeLabel,
  o_ as axErpCodeNameOf,
  s_ as axErpCompareSortValue,
  r_ as axErpDownload,
  vm as axErpEmptySetText,
  c_ as axErpFileName,
  l_ as axErpGisuLabel,
  i_ as axErpHttpMessage,
  d_ as axErpIsHelpKey,
  __ as axErpKeepInPlace,
  m_ as axErpKpiColumns,
  u_ as axErpMenuItem,
  p_ as axErpMenuSection,
  E_ as axErpMergeBase,
  f_ as axErpNextSort,
  b_ as axErpPageCount,
  y_ as axErpPageItems,
  g_ as axErpParsePage,
  h_ as axErpQtyDecimals,
  v_ as axErpQtyFormat,
  k_ as axErpQtyOutOfRange,
  N_ as axErpQtyParse,
  A_ as axErpQtyRound,
  w_ as axErpQtyStep,
  $_ as axErpQtyTimesUnit,
  x_ as axErpRangeValid,
  X_ as axErpRovingMove,
  C_ as axErpRowActivate,
  S_ as axErpSameValues,
  B_ as axErpSaveBlob,
  F_ as axErpSaveCsv,
  I_ as axErpSortForest,
  j_ as axErpSortMessage,
  L_ as axErpSortValue,
  D_ as axErpSubmitShortcutLabel,
  M_ as axErpTableToCsv,
  T_ as axErpTotalLabel,
  R_ as axErpWeekOf,
  P_ as clampErpPageMinWidth,
  ft as clearTokens,
  Wc as colors,
  zc as configureAuth,
  Yc as configureComments,
  O_ as csvFormulaGuard,
  q_ as csvNumber,
  pt as currencyDigits,
  _t as currencyText,
  Me as currentUsername,
  Xe as decodeClaims,
  Uc as ensureBaseCurrency,
  G_ as eraOf,
  W_ as eraShortDate,
  z_ as eraYearLabel,
  km as fmtAm,
  K_ as fmtDt,
  Nm as fmtDtMin,
  ut as fmtMoney,
  Am as fmtMoneyText,
  wm as fmtNum,
  $m as fmtNumBlank,
  xm as fmtNumDash,
  Xm as fmtYen,
  Te as getActiveAffiliation,
  Cm as getBaseCurrency,
  kt as getFreshToken,
  ve as getStoredToken,
  H_ as hasUnsavedHint,
  he as isExpired,
  at as isRefreshExpired,
  Bt as isReply,
  V_ as measureMoneyMetrics,
  U_ as moneyColWidth,
  Q_ as moneyColWidthForDigits,
  mt as moneyUnit,
  ye as notifySessionExpired,
  Vc as onActiveAffiliationChange,
  Kc as onSessionExpired,
  Xt as pickCurrencyCode,
  ot as refreshTokens,
  Et as saveTokens,
  Sm as setAXErpEmptySetText,
  Hc as setActiveAffiliation,
  et as setBaseCurrency,
  Y_ as setUnsavedHint,
  yt as startRefreshExpiryWatch,
  nt as stopRefreshExpiryWatch,
  J_ as textColWidth,
  Z_ as textWidth,
  Ct as toCurrency,
  Bm as toHalfWidth,
  em as todayLocal,
  tm as useAXErpBusy,
  am as useAXErpCalculator,
  nm as useAXErpConfirm,
  om as useAXErpDirtyGuard,
  sm as useAXErpEditor,
  rm as useAXErpFilePicker,
  cm as useAXErpNotice,
  lm as useAXErpPaged,
  im as useAXErpQuery,
  dm as useAXErpQuickMenu,
  _m as useAXErpRovingGrid,
  mm as useAXErpRunLock,
  um as useAXErpShortcutHelp,
  pm as useAXErpSubmitShortcut,
  Em as useAXErpToast,
  fm as useAXErpTree,
  Ze as useAXErpUid,
  Zc as useCommentCounts,
  Mt as useComments,
  St as useCurrency
};
